// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Player
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

[data-media-player] {
  width: 100%;
  display: inline-flex;
  align-items: center;
  position: relative;
  contain: style;
  box-sizing: border-box;
  -webkit-user-select: none;
          user-select: none;
}

[data-media-player] * {
  box-sizing: border-box;
}

:where([data-media-player][data-view-type='video']) {
  aspect-ratio: 16 / 9;
}

[data-media-player]:focus,
[data-media-player]:focus-visible {
  outline: none;
}

[data-media-player][data-view-type='video'][data-started]:not([data-controls]) {
  pointer-events: auto;
  cursor: none;
}

[data-media-player] slot {
  display: contents;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Provider
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

[data-media-provider] {
  display: flex;
  position: relative;
  box-sizing: border-box;
  align-items: center;
  border-radius: inherit;
  width: 100%;
  aspect-ratio: inherit;
  overflow: hidden;
}

[data-media-player]:not([data-view-type='audio']) [data-media-provider],
[data-media-player][data-fullscreen] [data-media-provider] {
  height: 100%;
}

[data-media-player][data-view-type='audio'] [data-media-provider] {
  display: contents;
  background-color: unset;
}

[data-media-provider] audio {
  width: 100%;
}

:where(video:not([width]):not([height]), iframe:not([width]):not([height])) {
  width: 100%;
  aspect-ratio: 16 / 9;
}

:where([data-media-provider] video),
:where([data-media-provider] iframe) {
  aspect-ratio: inherit;
  display: inline-block;
  height: auto;
  object-fit: contain;
  touch-action: manipulation;
  border-radius: inherit;
  width: 100%;
}

[data-media-provider] iframe {
  height: 100%;
}

[data-media-player][data-view-type='audio'] video,
[data-media-player][data-view-type='audio'] iframe {
  display: none;
}

[data-media-player][data-fullscreen] video {
  height: 100%;
}

[data-media-provider] iframe:not([src]) {
  display: none;
}

iframe.vds-youtube[data-no-controls] {
  height: 1000%;
}

.vds-blocker {
  position: absolute;
  inset: 0;
  width: 100%;
  height: auto;
  aspect-ratio: inherit;
  pointer-events: auto;
  border-radius: inherit;
  z-index: 1;
}

[data-ended] .vds-blocker {
  background-color: black;
}

.vds-icon:focus {
  outline: none;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Google Cast
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

.vds-google-cast {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #dedede;
  font-family: sans-serif;
  font-weight: 500;
}

.vds-google-cast svg {
  --size: max(18%, 40px);
  width: var(--size);
  height: var(--size);
  margin-bottom: 8px;
}

.vds-google-cast-info {
  font-size: calc(var(--media-height) / 100 * 6);
}

:where(.vds-buffering-indicator) {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 1;
}

:where(.vds-buffering-indicator) :where(.vds-buffering-icon, .vds-buffering-spinner) {
  opacity: 0;
  pointer-events: none;
  transition: var(--media-buffering-transition, opacity 200ms ease);
}

:where(.vds-buffering-indicator)
  :where(.vds-buffering-icon, svg.vds-buffering-spinner, .vds-buffering-spinner svg) {
  width: var(--media-buffering-size, 96px);
  height: var(--media-buffering-size, 96px);
}

:where(.vds-buffering-indicator) :where(.vds-buffering-track, circle[data-part='track']) {
  color: var(--media-buffering-track-color, #f5f5f5);
  opacity: var(--media-buffering-track-opacity, 0.25);
  stroke-width: var(--media-buffering-track-width, 8);
}

:where(.vds-buffering-indicator) :where(.vds-buffering-track-fill, circle[data-part='track-fill']) {
  color: var(--media-buffering-track-fill-color, var(--media-brand));
  opacity: var(--media-buffering-track-fill-opacity, 0.75);
  stroke-width: var(--media-buffering-track-fill-width, 9);
  stroke-dasharray: 100;
  stroke-dashoffset: var(--media-buffering-track-fill-offset, 50);
}

:where([data-buffering]) :where(.vds-buffering-icon, .vds-buffering-spinner) {
  opacity: 1;
  animation: var(--media-buffering-animation, vds-buffering-spin 1s linear infinite);
}

@keyframes vds-buffering-spin {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion) {
  :where([data-buffering]) :where(.vds-buffering-icon, .vds-buffering-spinner) {
    animation-duration: 8s;
  }
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Buttons
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-button) {
  -webkit-tap-highlight-color: transparent;
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  user-select: none;
  appearance: none;
  background: none;
  outline: none;
  border: none;
  border-radius: var(--media-button-border-radius, 8px);
  width: var(--media-button-size, 40px);
  height: var(--media-button-size, 40px);
  transition: transform 0.2s ease-out;
  contain: layout style;
  cursor: pointer;
  -webkit-user-select: none;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
  flex-shrink: 0;
}

.vds-button {
  border: var(--media-button-border);
  color: var(--media-button-color, var(--media-controls-color, #f5f5f5));
  padding: var(--media-button-padding, 0px);
}

:where([data-fullscreen] .vds-button) {
  width: var(--media-fullscreen-button-size, 42px);
  height: var(--media-fullscreen-button-size, 42px);
}

@media screen and (max-width: 599px) {
  :where([data-fullscreen] .vds-button) {
    width: var(--media-sm-fullscreen-button-size, 42px);
    height: var(--media-sm-fullscreen-button-size, 42px);
  }
}

:where(.vds-button .vds-icon) {
  width: var(--media-button-icon-size, 80%);
  height: var(--media-button-icon-size, 80%);
  border-radius: var(--media-button-border-radius, 8px);
}

:where(.vds-menu-button .vds-icon) {
  display: flex !important;
}

:where(.vds-button[aria-hidden='true']) {
  display: none !important;
}

@media (hover: hover) and (pointer: fine) {
  .vds-button:hover {
    background-color: var(--media-button-hover-bg, rgb(255 255 255 / 0.2));
  }

  .vds-button:hover {
    transform: var(--media-button-hover-transform, scale(1.05));
    transition: var(--media-button-hover-transition, transform 0.2s ease-in);
  }

  .vds-button[aria-expanded='true'] {
    transform: unset;
  }
}

@media (pointer: coarse) {
  .vds-button:hover {
    border-radius: var(--media-button-touch-hover-border-radius, 100%);
    background-color: var(--media-button-touch-hover-bg, rgb(255 255 255 / 0.2));
  }
}

:where(.vds-button:focus) {
  outline: none;
}

:where(.vds-button[data-focus], .vds-button:focus-visible) {
  box-shadow: var(--media-focus-ring);
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Live Button
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-live-button) {
  min-width: auto;
  min-height: auto;
  width: var(--media-live-button-width, 40px);
  height: var(--media-live-button-height, 40px);
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  appearance: none;
  background: none;
  outline: none;
  border: none;
}

:where(.vds-live-button-text) {
  font-family: var(--media-font-family, sans-serif);
  font-size: var(--media-live-button-font-size, 12px);
  font-weight: var(--media-live-button-font-weight, 600);
  letter-spacing: var(--media-live-button-letter-spacing, 1.5px);
  transition: color 0.3s ease;
}

.vds-live-button-text {
  background-color: var(--media-live-button-bg, #8a8a8a);
  border-radius: var(--media-live-button-border-radius, 2px);
  color: var(--media-live-button-color, #161616);
  padding: var(--media-live-button-padding, 1px 4px);
}

:where(.vds-live-button[data-focus] .vds-live-button-text) {
  box-shadow: var(--media-focus-ring);
}

:where(.vds-live-button[data-edge]) {
  cursor: unset;
}

.vds-live-button[data-edge] .vds-live-button-text {
  background-color: var(--media-live-button-edge-bg, #dc2626);
  color: var(--media-live-button-edge-color, #f5f5f5);
}

@media (pointer: fine) {
  :where(.vds-live-button:hover) {
    background-color: unset;
  }
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * States
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

/* Play Button */
.vds-button:not([data-paused]) .vds-play-icon,
.vds-button[data-ended] .vds-play-icon,
.vds-button[data-paused] .vds-pause-icon,
.vds-button[data-ended] .vds-pause-icon,
.vds-button:not([data-ended]) .vds-replay-icon,
/* PIP Button */
.vds-button[data-active] .vds-pip-enter-icon,
.vds-button:not([data-active]) .vds-pip-exit-icon,
/* Fullscreen Button */
.vds-button[data-active] .vds-fs-enter-icon,
.vds-button:not([data-active]) .vds-fs-exit-icon,
/* Caption Button */
.vds-button:not([data-active]) .vds-cc-on-icon,
.vds-button[data-active] .vds-cc-off-icon,
/* Mute Button */
.vds-button:not([data-muted]) .vds-mute-icon,
.vds-button:not([data-state='low']) .vds-volume-low-icon,
.vds-button:not([data-state='high']) .vds-volume-high-icon {
  display: none;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Captions
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-captions) {
  /* Recommended settings in the WebVTT spec (https://www.w3.org/TR/webvtt1). */
  --overlay-padding: var(--media-captions-padding, 1%);
  --cue-color: var(--media-user-text-color, var(--media-cue-color, white));
  --cue-bg-color: var(--media-user-text-bg, var(--media-cue-bg, rgba(0, 0, 0, 0.7)));
  --cue-default-font-size: var(--media-cue-font-size, calc(var(--overlay-height) / 100 * 4.5));
  --cue-font-size: calc(var(--cue-default-font-size) * var(--media-user-font-size, 1));
  --cue-line-height: var(--media-cue-line-height, calc(var(--cue-font-size) * 1.2));
  --cue-padding-x: var(--media-cue-padding-x, calc(var(--cue-font-size) * 0.6));
  --cue-padding-y: var(--media-cue-padding-x, calc(var(--cue-font-size) * 0.4));
  --cue-padding: var(--cue-padding-y) var(--cue-padding-x);
  position: absolute;
  inset: 0;
  z-index: 1;
  contain: layout style;
  margin: var(--overlay-padding);
  font-size: var(--cue-font-size);
  font-family: var(--media-user-font-family, sans-serif);
  box-sizing: border-box;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  word-spacing: normal;
  word-break: break-word;
}

:where([data-fullscreen][data-orientation='portrait'] .vds-captions) {
  --cue-default-font-size: var(--media-cue-font-size, calc(var(--overlay-width) / 100 * 4.5));
}

:where([data-view-type='audio'] .vds-captions) {
  position: relative;
  margin: 0;
}

:where(.vds-captions[aria-hidden='true']) {
  opacity: 0;
  visibility: hidden;
}

.vds-captions[data-example] {
  opacity: 1 !important;
  visibility: visible !important;
}

:where([data-view-type='video'] .vds-captions [data-part='cue-display'][data-example]) {
  --cue-text-align: center;
  --cue-width: 100%;
  --cue-top: 90%;
  --cue-left: 0%;
}

:where([data-view-type='audio'] .vds-captions [data-part='cue-display']) {
  --cue-width: 100%;
  position: relative !important;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * VTT Cues
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-captions [data-part='cue-display']) {
  position: absolute;
  direction: ltr;
  overflow: visible;
  contain: content;
  top: var(--cue-top);
  left: var(--cue-left);
  right: var(--cue-right);
  bottom: var(--cue-bottom);
  width: var(--cue-width, auto);
  height: var(--cue-height, auto);
  box-sizing: border-box;
  transform: var(--cue-transform);
  text-align: var(--cue-text-align);
  writing-mode: var(--cue-writing-mode, unset);
  white-space: pre-line;
  unicode-bidi: plaintext;
  min-width: min-content;
  min-height: min-content;
  background-color: var(--media-user-display-bg, var(--media-cue-display-bg));
  border-radius: var(--media-cue-display-border-radius);
}

.vds-captions [data-part='cue-display'] {
  padding: var(--media-cue-display-padding);
}

:where(.vds-captions[data-dir='rtl'] [data-part='cue-display']) {
  direction: rtl;
}

:where(.vds-captions [data-part='cue']) {
  display: inline-block;
  contain: content;
  font-variant: var(--media-user-font-variant);
  border: var(--media-cue-border, unset);
  border-radius: var(--media-cue-border-radius, 2px);
  backdrop-filter: var(--media-cue-backdrop, blur(8px));
  line-height: var(--cue-line-height);
  box-sizing: border-box;
  box-shadow: var(--media-cue-box-shadow, var(--cue-box-shadow));
  white-space: var(--cue-white-space, pre-wrap);
  outline: var(--cue-outline);
  text-shadow: var(--media-user-text-shadow, var(--cue-text-shadow));
}

.vds-captions [data-part='cue'] {
  background-color: var(--cue-bg-color);
  color: var(--cue-color);
  padding: var(--cue-padding);
}

:where(.vds-captions [data-part='cue-display'][data-vertical] [data-part='cue']) {
  --cue-padding: var(--cue-padding-x) var(--cue-padding-y);
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * VTT Regions
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-captions [data-part='region']) {
  --anchor-x-percent: calc(var(--region-anchor-x) / 100);
  --anchor-x: calc(var(--region-width) * var(--anchor-x-percent));
  --anchor-y-percent: calc(var(--region-anchor-y) / 100);
  --anchor-y: calc(var(--region-height) * var(--anchor-y-percent));
  --vp-anchor-x: calc(var(--region-viewport-anchor-x) * 1%);
  --vp-anchor-y-percent: calc(var(--region-viewport-anchor-y) / 100);
  --vp-anchor-y: calc(var(--overlay-height) * var(--vp-anchor-y-percent));
  position: absolute;
  display: inline-flex;
  flex-flow: column;
  justify-content: flex-start;
  width: var(--region-width);
  height: var(--region-height);
  min-height: 0px;
  max-height: var(--region-height);
  writing-mode: horizontal-tb;
  top: var(--region-top, calc(var(--vp-anchor-y) - var(--anchor-y)));
  left: var(--region-left, calc(var(--vp-anchor-x) - var(--anchor-x)));
  right: var(--region-right);
  bottom: var(--region-bottom);
  overflow: hidden;
  overflow-wrap: break-word;
  box-sizing: border-box;
}

:where(.vds-captions [data-part='region'][data-active]) {
}

:where(.vds-captions [data-part='region'][data-scroll='up']) {
  justify-content: end;
}

:where(.vds-captions [data-part='region'][data-active][data-scroll='up']) {
  transition: top 0.433s;
}

:where(.vds-captions [data-part='region'] > [data-part='cue-display']) {
  position: relative;
  width: auto;
  left: var(--cue-offset);
  height: var(--cue-height, auto);
  text-align: var(--cue-text-align);
  unicode-bidi: plaintext;
  margin-top: 2px;
}

:where(.vds-captions [data-part='region'] [data-part='cue']) {
  position: relative;
  border-radius: 0px;
}

:where(.vds-chapter-title) {
  --color: var(--media-chapter-title-color, rgba(255 255 255 / 0.64));
  display: inline-block;
  font-family: var(--media-font-family, sans-serif);
  font-size: var(--media-chapter-title-font-size, 16px);
  font-weight: var(--media-chapter-title-font-weight, 400);
  color: var(--color);
  flex: 1 1;
  padding-inline: 6px;
  overflow: hidden;
  text-align: start;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.vds-chapter-title::before {
  content: var(--media-chapter-title-separator, '\\2022');
  display: inline-block;
  margin-right: var(--media-chapter-title-separator-gap, 6px);
  color: var(--media-chapter-title-separator-color, var(--color));
}

.vds-chapter-title:empty::before {
  content: '';
  margin: 0;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Controls
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-controls),
:where(.vds-controls-group) {
  position: relative;
  display: inline-block;
  width: 100%;
  box-sizing: border-box;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Audio Controls
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where([data-view-type='audio'] .vds-controls) {
  display: inline-block;
  max-width: 100%;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Video Controls
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where([data-view-type='video'] .vds-controls) {
  display: flex;
  position: absolute;
  flex-direction: column;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  padding: var(--media-controls-padding, 0px);
  transition: var(--media-controls-out-transition, opacity 0.2s ease-out);
}

:where([data-view-type='video'] .vds-controls[data-visible]) {
  opacity: 1;
  visibility: visible;
  transition: var(--media-controls-in-transition, opacity 0.2s ease-in);
}

:where(.vds-controls-spacer) {
  flex: 1 1;
  pointer-events: none;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Gesture
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-gestures) {
  display: contents;
}

:where(.vds-gesture) {
  position: absolute;
  display: block;
  contain: content;
  z-index: 0;
  opacity: 0;
  visibility: hidden;
  pointer-events: none !important;
}

:where(.vds-icon svg) {
  display: block;
  width: 100%;
  height: 100%;
  vertical-align: middle;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Keyboard Action
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-kb-action.hidden) {
  opacity: 0;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Keyboard Text
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-kb-text-wrapper) {
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  top: var(--media-kb-text-top, 10%);
  z-index: 20;
  pointer-events: none;
}

:where(.vds-kb-text) {
  display: inline-block;
  font-size: var(--media-kb-text-size, 150%);
  font-family: var(--media-font-family, sans-serif);
  backdrop-filter: blur(2px);
  border-radius: var(--media-kb-border-radius, 2.5px);
  pointer-events: none;
}

.vds-kb-text {
  color: var(--media-kb-text-color, var(--default-color));
  background-color: var(--media-kb-text-bg, var(--default-bg));
  padding: var(--media-kb-text-padding, 10px 20px);
}

.light .vds-kb-text {
  --default-color: #1a1a1a;
  --default-bg: rgb(240 240 240 / 0.6);
}

.dark .vds-kb-text {
  --default-color: #f5f5f5;
  --default-bg: rgb(10 10 10 / 0.6);
}

:where(.vds-kb-text:empty) {
  display: none;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Keyboard Bezel
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-kb-bezel) {
  --size: var(--media-kb-bezel-size, 52px);
  position: absolute;
  left: 50%;
  top: 45%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: var(--size);
  height: var(--size);
  margin-left: calc(-1 * calc(var(--size) / 2));
  margin-right: calc(-1 * calc(var(--size) / 2));
  z-index: 20;
  backdrop-filter: blur(2px);
  background-color: var(--media-kb-bezel-bg, var(--default-bg));
  animation: var(--media-kb-bezel-animation, vds-bezel-fade 0.35s linear 1 normal forwards);
  border-radius: var(--media-kb-bezel-border-radius, calc(var(--size) / 2));
  pointer-events: none;
}

.vds-kb-bezel:not(:has(svg)) {
  display: none !important;
}

.light .vds-kb-bezel {
  --default-bg: rgb(255 255 255 / 0.6);
}

.dark .vds-kb-bezel {
  --default-bg: rgb(10 10 10 / 0.6);
}

@media (prefers-reduced-motion) {
  :where(.vds-kb-bezel) {
    animation: none;
  }
}

:where(.vds-kb-bezel:has(slot:empty)) {
  opacity: 0;
}

:where(.vds-kb-action[data-action='seek-forward'] .vds-kb-bezel) {
  top: 45%;
  left: unset;
  right: 10%;
}

:where(.vds-kb-action[data-action='seek-backward'] .vds-kb-bezel) {
  top: 45%;
  left: 10%;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Keyboard Icon
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-kb-icon) {
  --size: var(--media-kb-icon-size, 38px);
  width: var(--size);
  height: var(--size);
}

.vds-kb-icon {
  color: var(--media-kb-icon-color, var(--default-color));
}

.light .vds-kb-icon {
  --default-color: #1a1a1a;
}

.dark .vds-kb-icon {
  --default-color: #f5f5f5;
}

@keyframes vds-bezel-fade {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: scale(2);
  }
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Theme
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-menu-items) {
  --color-inverse: var(--media-menu-color-inverse, var(--default-inverse));
  --color-gray-50: var(--media-menu-color-gray-50, var(--default-gray-50));
  --color-gray-100: var(--media-menu-color-gray-100, var(--default-gray-100));
  --color-gray-200: var(--media-menu-color-gray-200, var(--default-gray-200));
  --color-gray-300: var(--media-menu-color-gray-300, var(--default-gray-300));
  --color-gray-400: var(--media-menu-color-gray-400, var(--default-gray-400));

  --text-color: var(--media-menu-text-color, var(--default-text));
  --text-secondary-color: var(--media-menu-text-secondary-color, var(--default-text-secondary));

  --root-border: var(--media-menu-border, var(--default-root-border));
}

.light .vds-menu-items {
  --default-inverse: black;
  --default-gray-50: rgb(80 80 80 / 0.15);
  --default-gray-100: rgb(80 80 80 / 0.45);
  --default-gray-200: rgb(235 235 235 / 0.6);
  --default-gray-300: rgb(238 238 238);
  --default-gray-400: rgb(250 250 250);

  --default-text: #1a1a1a;
  --default-text-secondary: #6b6b6b;

  --default-root-border: 1px solid rgb(10 10 10 / 0.1);
}

.dark .vds-menu-items {
  --default-inverse: white;
  --default-gray-50: rgb(245 245 245 / 0.1);
  --default-gray-100: rgb(245 245 245 / 0.45);
  --default-gray-200: rgb(10 10 10 / 0.6);
  --default-gray-300: rgb(27 27 27);
  --default-gray-400: rgb(10 10 10);

  --default-text: #f5f5f5;
  --default-text-secondary: #8a8a8a;

  --default-root-border: 1px solid rgb(255 255 255 / 0.1);
}

:where(.vds-menu-items) {
  --font-family: var(--media-font-family, sans-serif);
  --font-size: var(--media-menu-font-size, 14px);
  --font-weight: var(--media-menu-font-weight, 500);

  --root-bg: var(--media-menu-bg, var(--color-gray-400));
  --root-padding: var(--media-menu-padding, 12px);
  --root-border-radius: var(--media-menu-border-radius, 4px);

  --divider: var(--media-menu-divider, 1px solid var(--color-gray-50));

  --section-bg: var(--media-menu-section-bg, var(--color-gray-300));
  --section-border: var(--media-menu-section-border);
  --section-divider: var(--media-menu-section-divider, var(--divider));

  --top-bar-bg: var(--media-menu-top-bar-bg, var(--color-gray-200));
  --top-bar-divider: var(--media-menu-divider, transparent);

  --text-hint-color: var(--media-menu-hint-color, var(--text-secondary-color));

  --chapter-divider: var(--media-chapters-divider, var(--divider));
  --chapter-active-bg: var(--media-chapters-item-active-bg, var(--color-gray-50));
  --chapter-active-border-left: var(--media-chapters-item-active-border-left);

  --chapter-progress-bg: var(--media-chapters-progress-bg, var(--color-inverse));

  --chapter-time-font-size: var(--media-chapters-time-font-size, 12px);
  --chapter-time-font-weight: var(--media-chapters-time-font-weight, 500);
  --chapter-time-gap: var(--media-chapters-time-gap, 6px);

  --chapter-duration-bg: var(--media-chapters-duration-bg);

  --item-border: var(--media-menu-item-border, 0);
  --item-bg: var(--media-menu-item-bg, transparent);
  --item-hover-bg: var(--media-menu-item-hover-bg, var(--color-gray-50));
  --item-icon-size: var(--media-menu-item-icon-size, 18px);
  --item-padding: var(--media-menu-item-padding, 10px);
  --item-min-height: var(--media-menu-item-height, 40px);
  --item-border-radius: var(--media-menu-item-border-radius, 2px);

  --scrollbar-track-bg: var(--media-menu-scrollbar-track-bg, transparent);
  --scrollbar-thumb-bg: var(--media-menu-scrollbar-thumb-bg, var(--color-gray-50));
  --webkit-scrollbar-bg: var(--color-gray-400);
  --webkit-scrollbar-track-bg: var(--media-menu-scrollbar-track-bg, var(--color-gray-50));

  --checkbox-bg: var(--media-menu-checkbox-bg, var(--color-gray-100));
  --checkbox-active-bg: var(--media-menu-checkbox-bg-active, #1ba13f);
  --checkbox-handle-bg: var(--media-menu-checkbox-handle-bg, #f5f5f5);
  --checkbox-handle-border: var(--media-menu-checkbox-handle-border);

  --radio-icon-color: var(--media-menu-radio-icon-color, var(--text-color));
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Menu
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-menu[data-root] media-menu[data-root]) {
  display: contents;
}

:where(.vds-menu) {
  font-family: var(--font-family);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
}

:where(.vds-menu[data-disabled][data-root]) {
  display: none;
}

:where(.vds-menu[data-submenu]) {
  display: inline-block;
}

:where(.vds-menu-items:focus) {
  outline: none;
}

:where(.vds-menu-item:focus, .vds-radio:focus) {
  outline: none;
}

:where(
    .vds-menu-item:focus-visible,
    .vds-menu-item[data-focus],
    .vds-radio:focus-visible,
    .vds-radio[data-focus]
  ) {
  outline: none;
  box-shadow: var(--media-focus-ring);
}

:where(.vds-menu[data-open] .vds-tooltip-content) {
  display: none !important;
}

.vds-menu-items [data-hidden] {
  display: none !important;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Scroll
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

@media (prefers-reduced-motion: no-preference) {
  :where(.vds-menu-items) {
    scroll-behavior: smooth;
  }
}

:where(.vds-menu-items) {
  box-sizing: border-box;
  min-width: var(--media-menu-min-width, 280px);
  scrollbar-width: thin;
  scrollbar-color: var(--scrollbar-thumb-bg) var(--scrollbar-track-bg);
  transform: translate3d(0, 0, 0);
}

:where(.vds-menu-items)::-webkit-scrollbar {
  background-color: var(--webkit-scrollbar-bg);
  border-radius: var(--root-border-radius);
  height: 6px;
  width: 5px;
}

:where(.vds-menu-items)::-webkit-scrollbar-track {
  background-color: var(--webkit-scrollbar-track-bg);
  border-radius: 4px;
}

:where(.vds-menu-items)::-webkit-scrollbar-thumb {
  background-color: var(--scrollbar-thumb-bg);
  border-radius: 4px;
}

:where(.vds-menu-items)::-webkit-scrollbar-corner {
  background-color: var(--scrollbar-thumb-bg);
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Menu Button
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-menu-button) {
  outline: none;
  box-sizing: border-box;
}

:where(.vds-menu-button .vds-rotate-icon) {
  transition: transform 0.2s ease-out;
}

:where(.vds-menu-button[aria-expanded='true'] .vds-rotate-icon) {
  transform: rotate(var(--media-menu-icon-rotate-deg, 90deg));
  transition: transform 0.2s ease-in;
}

:where(.vds-menu-button) {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

@media (prefers-reduced-motion) {
  :where(.vds-menu-button .vds-rotate-icon) {
    transition: unset;
  }
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Menu Items
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-menu-items) {
  display: flex;
  align-items: center;
  flex-direction: column;
  font-family: var(--font-family);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  transition: height 0.35s ease;
}

@media (prefers-reduced-motion) {
  :where(.vds-menu-items) {
    transition: unset;
  }
}

:where(.vds-menu-items[data-root]) {
  background-color: var(--root-bg);
  border-radius: var(--root-border-radius);
  box-shadow: var(--media-menu-box-shadow);
  backdrop-filter: blur(4px);
  height: var(--menu-height, auto);
  will-change: width, height;
  overflow-y: auto;
  overscroll-behavior: contain;
  opacity: 0;
  z-index: 9999999;
  box-sizing: border-box;
  max-height: var(--media-menu-max-height, 250px);
  filter: var(
    --media-menu-filter,
    drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06))
  );
}

.vds-menu-items[data-root] {
  border: var(--root-border);
  padding: var(--root-padding);
}

:where([data-view-type='video']) :where(.vds-menu-items[data-root]) {
  max-height: var(--media-menu-video-max-height, calc(var(--player-height) * 0.7));
}

:where(.vds-menu-items[data-transition='height']) {
  --scrollbar-thumb-bg: rgba(0, 0, 0, 0);
  pointer-events: none;
  overflow: hidden;
}

.vds-menu-button[aria-disabled='true'],
.vds-menu-item[aria-disabled='true'],
.vds-menu-item[data-disabled] {
  display: none;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Menu Items Animation
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-menu-items[data-root]) {
  --enter-transform: translateY(0px);
  --exit-transform: translateY(12px);
}

/* Mobile Popup */
:where(.vds-menu-items[data-root]:not([data-placement])) {
  --enter-transform: translateY(-24px);
}

:where(.vds-menu-items[data-root][aria-hidden='true']) {
  animation: var(--media-menu-exit-animation, vds-menu-exit 0.2s ease-out);
}

:where(.vds-menu-items[data-root][aria-hidden='false']) {
  animation: var(--media-menu-enter-animation, vds-menu-enter 0.3s ease-out);
  animation-fill-mode: forwards;
}

/* Bottom */
:where(.vds-menu-items[data-placement~='bottom']) {
  --enter-transform: translateY(0);
  --exit-transform: translateY(-12px);
}

@keyframes vds-menu-enter {
  from {
    opacity: 0;
    transform: var(--exit-transform);
  }
  to {
    opacity: 1;
    transform: var(--enter-transform);
  }
}

@keyframes vds-menu-exit {
  from {
    opacity: 1;
    transform: var(--enter-transform);
  }
  to {
    opacity: 0;
    transform: var(--exit-transform);
  }
}

@media (prefers-reduced-motion) {
  :where(.vds-menu-items) {
    animation: none;
    opacity: 1;
  }
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Menu Portal
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(media-menu-portal) {
  display: contents;
}

:where(.vds-menu-items[data-root]:not([data-placement])) {
  position: fixed;
  left: 16px;
  right: 16px;
  top: unset;
  bottom: 0;
  max-height: var(--media-sm-menu-portrait-max-height, 40vh);
  max-height: var(--media-sm-menu-portrait-max-height, 40dvh);
}

:where(.vds-menu-items[data-root]:not([data-placement])) {
  max-width: 480px;
  margin: 0 auto;
}

@media (orientation: landscape) and (pointer: coarse) {
  :where(.vds-menu-items[data-root]:not([data-placement])) {
    max-height: var(--media-sm-menu-landscape-max-height, min(70vh, 400px));
    max-height: var(--media-sm-menu-landscape-max-height, min(70dvh, 400px));
  }
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Submenu
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-menu[data-submenu] .vds-menu-button) {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

:where(.vds-menu-items[data-submenu]) {
  width: 100%;
}

:where(.vds-menu[aria-hidden='true']),
:where(.vds-menu-items[data-submenu][aria-hidden='true']) {
  display: none;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Menu Item
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-menu-item, .vds-radio) {
  position: relative;
  -webkit-tap-highlight-color: transparent;
  -webkit-user-select: none;
          user-select: none;
  display: flex;
  align-items: center;
  justify-content: left;
  width: 100%;
  appearance: none;
  border: 0;
  border-radius: var(--item-border-radius);
  box-sizing: border-box;
  min-height: var(--item-min-height);
  font-size: var(--font-size);
  outline: none;
}

.vds-menu-item,
.vds-radio {
  color: var(--text-color);
  background-color: var(--item-bg);
  padding: var(--item-padding);
}

.vds-menu-item:focus-visible,
.vds-menu-item[data-focus],
.vds-radio:focus-visible,
.vds-radio[data-focus] {
  cursor: pointer;
  background-color: var(--item-hover-bg);
}

@media (hover: hover) and (pointer: fine) {
  .vds-menu-item[role]:hover,
  .vds-radio:hover {
    cursor: pointer;
    background-color: var(--item-hover-bg);
  }
}

:where(.vds-menu-items[data-submenu]) {
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
}

:where(.vds-menu-item[aria-expanded='true']) {
  font-weight: bold;
  border-radius: 0;
  border-top-left-radius: var(--item-border-radius);
  border-top-right-radius: var(--item-border-radius);
}

.vds-menu-item[aria-expanded='true'] {
  border-bottom: var(--top-bar-divider);
}

:where(.vds-menu-item[aria-expanded='true']) {
  position: sticky;
  top: calc(-1 * var(--root-padding));
  left: 0;
  width: 100%;
  z-index: 10;
  backdrop-filter: blur(4px);
  margin-bottom: 4px;
}

.vds-menu-item[aria-expanded='true'] {
  background-color: var(--top-bar-bg);
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Menu Item Parts
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-menu-item-label) {
  flex: 1 0;
  text-align: start;
}

:where(.vds-menu-item .vds-icon, .vds-radio .vds-icon) {
  --size: var(--item-icon-size);
  width: var(--size);
  height: var(--size);
  margin-right: var(--media-menu-item-icon-spacing, 6px);
}

:where(.vds-menu-open-icon, .vds-menu-close-icon) {
  --size: var(--media-menu-arrow-icon-size, 18px);
  width: var(--size);
  height: var(--size);
}

:where(.vds-menu-item-hint, .vds-menu-open-icon, .vds-radio-hint) {
  color: var(--text-hint-color);
  font-size: var(--media-menu-hint-font-size, 13px);
  font-weight: var(--media-menu-hint-font-weight, 400);
}

:where(.vds-menu-items .vds-menu-open-icon) {
  margin-right: 0;
}

:where(.vds-menu-items) :where(.vds-menu-item-hint, .vds-menu-open-icon) {
  margin-left: auto;
}

:where(.vds-menu-items) :where(.vds-menu-item-hint + .vds-menu-open-icon),
:where(.vds-menu-item-hint + media-icon .vds-menu-open-icon),
:where(.vds-menu-item-hint + slot > .vds-menu-open-icon) {
  margin-left: 2px;
}

:where(.vds-menu-item[aria-hidden='true']),
:where(.vds-menu-item[aria-expanded='true'] .vds-menu-open-icon) {
  display: none !important;
}

:where(.vds-menu-items)
  :where(.vds-menu-item[aria-disabled='true'], .vds-menu-item[data-disabled])
  :where(.vds-menu-open-icon) {
  opacity: 0;
}

:where(.vds-menu-close-icon),
:where(.vds-menu-item[aria-expanded='true'] > .vds-icon) {
  display: none !important;
}

:where(.vds-menu-item[aria-expanded='true'] .vds-menu-close-icon) {
  display: inline !important;
  margin-left: calc(-1 * var(--item-padding) / 2);
}
/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Checkbox
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-menu-checkbox) {
  --checkbox-width: var(--media-menu-checkbox-width, 40px);
  --checkbox-height: var(--media-menu-checkbox-height, 18px);
  --checkbox-top: calc((var(--checkbox-height) - var(--checkbox-diameter)) / 2);
  --checkbox-diameter: var(
    --media-menu-checkbox-handle-diameter,
    calc(var(--checkbox-height) - 2px)
  );
  --checkbox-gap: var(--media-menu-checkbox-gap, 2.5px);
  position: relative;
  display: inline-block;
  width: var(--checkbox-width);
  height: var(--checkbox-height);
  border-radius: calc(var(--checkbox-height) / 2);
  transition: 0.3s all ease-in-out;
  box-sizing: border-box;
  cursor: pointer;
  pointer-events: auto;
}

.vds-menu-checkbox {
  background-color: var(--checkbox-bg);
}

:where(.vds-menu-checkbox:focus-visible) {
  outline: none;
  box-shadow: var(--media-focus-ring);
}

.vds-menu-checkbox[aria-checked='true'] {
  background-color: var(--checkbox-active-bg);
}

:where(.vds-menu-checkbox)::after {
  content: '';
  display: inline-block;
  width: var(--checkbox-diameter);
  height: var(--checkbox-diameter);
  border-radius: calc(var(--checkbox-diameter) / 2);
  position: absolute;
  top: var(--checkbox-top);
  transform: translateX(var(--checkbox-gap));
  transition: 0.3s all ease-in-out;
  border: var(--checkbox-handle-border);
  box-sizing: border-box;
}

.vds-menu-checkbox::after {
  background-color: var(--checkbox-handle-bg);
}

:where(.vds-menu-checkbox[aria-checked='true'])::after {
  transform: translateX(
    calc(var(--checkbox-width) - var(--checkbox-diameter) - var(--checkbox-gap))
  );
}

@media (prefers-reduced-motion: no-preference) {
  :where(.vds-menu-checkbox[data-active])::after {
    width: calc(var(--checkbox-width) - calc(var(--checkbox-gap) * 2));
  }
}

:where(.vds-menu-checkbox[aria-checked='true'][data-active])::after {
  transform: translateX(var(--checkbox-gap));
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Slider
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-menu-items .vds-slider) {
  --media-slider-track-bg: var(--media-menu-slider-track-bg, var(--color-gray-50));
  --media-slider-track-fill-bg: var(--media-menu-slider-track-fill-bg, var(--color-inverse));
  --media-slider-height: var(--media-menu-slider-height, 32px);
  --track-focus-height: var(--track-height) !important;
}

:where(.vds-menu-items .vds-slider-thumb) {
  opacity: 1 !important;
}

:where(.vds-menu-slider-item.group) {
  flex-direction: column;
}

:where(.vds-menu-slider-title) {
  margin-top: 4px;
}

:where(.vds-menu-slider-body) {
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 6px;
}

:where(.vds-menu-slider-item .vds-icon) {
  margin: 0;
  color: var(--text-hint-color);
}

:where(
    .vds-menu-slider-item[data-min] .vds-icon.down,
    .vds-menu-slider-item[data-max] .vds-icon.up
  ) {
  color: var(--text-color);
  animation: 0.6s ease-in-out vds-slider-icon;
  transition: all 1.2s ease;
}

@keyframes vds-slider-icon {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}

:where(.vds-menu-items .vds-slider-track-fill) {
  transition: opacity 0.3s ease;
}

:where(.vds-menu-items .vds-slider[data-active] .vds-slider-track-fill) {
  opacity: 0;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Radio
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-radio-group) {
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.vds-radio {
  cursor: pointer;
  contain: content;
  padding-left: calc(var(--item-icon-size) + var(--item-padding));
}

.vds-radio[aria-checked='true'] {
  padding-left: 0;
}

.vds-radio .vds-icon {
  display: none;
  color: var(--radio-icon-color);
}

.vds-radio[aria-checked='true'] .vds-icon {
  display: inline-block;
  margin-left: 6px;
}

:where(.vds-radio-hint) {
  margin-left: auto;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Color Picker
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

.vds-color-picker {
  width: 32px;
  height: 32px;
  border: 0;
  background-color: transparent;
  outline: none;
}

.vds-color-picker::-webkit-color-swatch {
  border-radius: 2px;
}

.vds-color-picker::-moz-color-swatch {
  border-radius: 2px;
}

.vds-color-picker:focus-visible::-webkit-color-swatch {
  box-shadow: var(--media-focus-ring);
}

.vds-color-picker:focus-visible::-moz-color-swatch {
  box-shadow: var(--media-focus-ring);
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Menu Section
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-menu-section) {
  width: 100%;
}

:where(.vds-menu-item + .vds-menu-section) {
  margin-top: 8px;
}

:where(.vds-menu-section + .vds-menu-section) {
  margin-top: 24px;
}

:where(.vds-menu-section:first-child) {
  margin-top: 8px;
}

:where(.vds-menu-section:last-child) {
  margin-bottom: 8px;
}

:where(.vds-menu-section-title),
:where(.vds-menu-slider-title) {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: var(--text-secondary-color);
  font-size: var(--media-menu-section-header-font-size, 12px);
  font-weight: var(--media-menu-section-header-font-weight, 500);
  padding-inline: 2px;
}

:where(.vds-menu-section-body) {
  width: 100%;
}

:where(.vds-menu-section-title + .vds-menu-section-body) {
  margin-top: var(--media-menu-section-gap, 8px);
}

.vds-menu-section-body {
  background-color: var(--section-bg);
  border: var(--section-border);
  border-radius: var(--media-menu-section-border-radius, 2px);
}

:where(.vds-menu-section:not([data-open]) .vds-menu-item:not(:last-child)) {
  border-bottom: var(--section-divider);
}

:where(.vds-menu-section-body .vds-menu:last-child > .vds-menu-item) {
  border-bottom: unset;
}

.vds-menu-section[data-open],
.vds-menu-section[data-open] > .vds-menu-section-body {
  display: contents !important;
  background-color: transparent !important;
}

.vds-menu-section[data-open] > .vds-menu-section-title,
.vds-menu-section[data-open] > .vds-menu-section-body > :not([data-open]) {
  display: none;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Chapters Menu
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-chapters-menu-items) {
  min-width: var(--media-chapters-min-width, var(--media-menu-min-width, 220px));
}

.vds-chapters-menu-items {
  padding: var(--media-chapters-padding, 0);
}

:where(.vds-menu-items:has(.vds-chapters-radio-group[data-thumbnails])) {
  min-width: var(--media-chapters-with-thumbnails-min-width, 300px);
}

:where(.vds-chapter-radio) {
  border-radius: 0;
}

.vds-chapter-radio {
  border-bottom: var(--chapter-divider);
  padding: var(--item-padding);
}

.vds-chapter-radio[aria-checked='true'] {
  padding-left: var(--item-padding);
}

:where(.vds-chapter-radio:last-child) {
  border-bottom: 0;
}

.vds-chapter-radio[aria-checked='true'] {
  background-color: var(--chapter-active-bg);
  border-left: var(--chapter-active-border-left);
}

:where(.vds-chapter-radio[aria-checked='true']):after {
  content: ' ';
  width: var(--progress);
  height: var(--media-chapters-progress-height, 4px);
  position: absolute;
  bottom: 0;
  left: 0;
}

.vds-chapter-radio[aria-checked='true']:after {
  border-radius: var(--media-chapters-progress-border-radius, 0);
  background-color: var(--chapter-progress-bg);
}

.vds-chapters-radio-group :where(.vds-thumbnail) {
  margin-right: var(--media-chapters-thumbnail-gap, 12px);
  flex-shrink: 0;
  min-width: var(--media-chapters-thumbnail-min-width, 100px);
  min-height: var(--media-chapters-thumbnail-min-height, 56px);
  max-width: var(--media-chapters-thumbnail-max-width, 120px);
  max-height: var(--media-chapters-thumbnail-max-height, 68px);
}

.vds-chapters-radio-group .vds-thumbnail {
  border: var(--media-chapters-thumbnail-border, 0);
}

:where(.vds-chapters-radio-group .vds-chapter-radio-label) {
  color: var(--text-secondary-color);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  white-space: nowrap;
}

:where(.vds-chapter-radio[aria-checked='true'] .vds-chapter-radio-label) {
  color: var(--text-color);
}

:where(.vds-chapters-radio-group .vds-chapter-radio-start-time) {
  display: inline-block;
  letter-spacing: var(--media-chapters-start-time-letter-spacing, 0.4px);
  border-radius: var(--media-chapters-start-time-border-radius, 2px);
  font-size: var(--chapter-time-font-size);
  font-weight: var(--chapter-time-font-weight);
  margin-top: var(--chapter-time-gap);
}

.vds-chapters-radio-group .vds-chapter-radio-start-time {
  color: var(--text-secondary-color);
  background-color: var(--section-bg);
  padding: var(--media-chapters-start-time-padding, 1px 4px);
}

:where(.vds-chapters-radio-group .vds-chapter-radio-duration) {
  color: var(--text-hint-color);
  font-size: var(--chapter-time-font-size);
  font-weight: var(--chapter-time-font-weight);
  margin-top: var(--chapter-time-gap);
}

.vds-chapters-radio-group .vds-chapter-radio-duration {
  background-color: var(--chapter-duration-bg);
  border-radius: var(--media-chapters-duration-border-radius, 2px);
}

.vds-chapters-radio-group:not([data-thumbnails]) :where(.vds-thumbnail, media-thumbnail) {
  display: none;
}

:where(.vds-chapter-radio-content) {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}

:where(.vds-chapters-radio-group:not([data-thumbnails]) .vds-chapter-radio-content) {
  width: 100%;
  flex-direction: row;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

:where(.vds-chapters-radio-group:not([data-thumbnails]) .vds-chapter-radio-start-time) {
  margin-top: 0;
  margin-left: auto;
}

:where(.vds-chapters-radio-group:not([data-thumbnails]) .vds-chapter-radio-duration) {
  margin-top: 4px;
  flex-basis: 100%;
}

.vds-menu-items[data-keyboard] .vds-chapters-radio-group:focus-within {
  padding: var(--media-chapters-focus-padding, 4px);
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Poster
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-poster) {
  display: block;
  contain: content;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  border: 0;
  pointer-events: none;
  box-sizing: border-box;
  transition: opacity 0.2s ease-out;
  background-color: var(--media-poster-bg, black);
}

:where(.vds-poster img) {
  object-fit: inherit;
  object-position: inherit;
  pointer-events: none;
  user-select: none;
  -webkit-user-select: none;
  box-sizing: border-box;
}

.vds-poster :where(img) {
  border: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

:where(.vds-poster[data-hidden]) {
  display: none;
}

:where(.vds-poster[data-visible]) {
  opacity: 1;
}

.vds-poster:not(:defined),
.vds-poster img:not([src]) {
  display: none;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Sliders
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-slider) {
  --width: var(--media-slider-width, 100%);
  --height: var(--media-slider-height, 48px);

  --thumb-size: var(--media-slider-thumb-size, 15px);
  --thumb-focus-size: var(--media-slider-focused-thumb-size, calc(var(--thumb-size) * 1.1));

  --track-width: var(--media-slider-track-width, 100%);
  --track-height: var(--media-slider-track-height, 5px);
  --track-focus-width: var(--media-slider-focused-track-width, var(--track-width));
  --track-focus-height: var(--media-slider-focused-track-height, calc(var(--track-height) * 1.25));

  display: inline-flex;
  align-items: center;
  width: var(--width);
  height: var(--height);
  /** Prevent thumb flowing out of slider. */
  margin: 0 calc(var(--thumb-size) / 2);
  position: relative;
  contain: layout style;
  outline: none;
  pointer-events: auto;
  cursor: pointer;
  user-select: none;
  touch-action: none;
  -webkit-user-select: none;
  -webkit-tap-highlight-color: transparent;
}

:where(.vds-slider[aria-hidden='true']) {
  display: none !important;
}

:where(.vds-slider[aria-disabled='true']) {
  cursor: unset;
}

:where(.vds-slider:focus) {
  outline: none;
}

:where(.vds-slider:not([data-chapters])[data-focus], .vds-slider:not([data-chapters]):focus-visible)
  :where(.vds-slider-track) {
  box-shadow: var(--media-focus-ring);
}

:where(.vds-slider .vds-slider-track) {
  z-index: 0;
  position: absolute;
  width: var(--track-width);
  height: var(--track-height);
  top: 50%;
  left: 0;
  border-radius: var(--media-slider-track-border-radius, 2px);
  transform: translateY(-50%) translateZ(0);
  background-color: var(--media-slider-track-bg, rgb(255 255 255 / 0.3));
  contain: strict;
}

:where(.vds-slider[data-focus], .vds-slider:focus-visible) :where(.vds-slider-track) {
  outline-offset: var(--thumb-size);
}

:where(.vds-slider:not([data-chapters])[data-active] .vds-slider-track) {
  width: var(--track-focus-width);
  height: var(--track-focus-height);
}

:where(.vds-slider .vds-slider-track-fill) {
  z-index: 2; /** above track and track progress. */
  background-color: var(--media-slider-track-fill-bg, var(--media-brand));
  width: var(--slider-fill, 0%);
  will-change: width;
}

:where(.vds-slider .vds-slider-thumb) {
  position: absolute;
  top: 50%;
  left: var(--slider-fill);
  opacity: 0;
  contain: layout size style;
  width: var(--thumb-size);
  height: var(--thumb-size);
  border: var(--media-slider-thumb-border, 1px solid #cacaca);
  border-radius: var(--media-slider-thumb-border-radius, 9999px);
  background-color: var(--media-slider-thumb-bg, #fff);
  transform: translate(-50%, -50%) translateZ(0);
  transition: opacity 0.15s ease-in;
  pointer-events: none;
  will-change: left;
  z-index: 2; /** above track fill. */
}

:where(.vds-slider[data-dragging], .vds-slider[data-focus], .vds-slider:focus-visible)
  :where(.vds-slider-thumb) {
  box-shadow: var(--media-slider-focused-thumb-shadow, 0 0 0 4px hsla(0, 0%, 100%, 0.4));
}

:where(.vds-slider[data-active] .vds-slider-thumb) {
  opacity: 1;
  transition: var(--media-slider-thumb-transition, opacity 0.2s ease-in, box-shadow 0.2s ease);
}

:where(.vds-slider[data-dragging] .vds-slider-thumb) {
  width: var(--thumb-focus-size);
  height: var(--thumb-focus-size);
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Slider Value
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-slider-value) {
  display: inline-block;
  contain: content;
  font-size: 14px;
  font-family: var(--media-font-family, sans-serif);
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Slider Thumbnail
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-slider-thumbnail) {
  display: block;
  contain: content;
  box-sizing: border-box;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Slider Video
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-slider-video) {
  background-color: black;
  box-sizing: border-box;
  contain: content;
  display: inline-block;
  border: var(--media-thumbnail-border, 1px solid white);
}

:where(.vds-slider-video video) {
  display: block;
  height: auto;
  width: 156px;
}

/* Temporarily hide video while loading. */
:where(.vds-slider-video[data-loading]) {
  opacity: 0;
}

/* Hide video if it fails to load. */
:where(.vds-slider-video[data-hidden], .vds-slider-video[data-hidden] video) {
  display: none;
  width: 0px;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Previews
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-slider .vds-slider-preview) {
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: 0;
  background-color: var(--media-slider-preview-bg);
  border-radius: var(--media-slider-preview-border-radius, 2px);
  pointer-events: none;
  transition: opacity 0.2s ease-out;
  will-change: left, opacity;
  contain: layout paint style;
}

:where(.vds-slider-preview[data-visible]) {
  opacity: 1;
  transition: opacity 0.2s ease-in;
}

.vds-slider-value {
  background-color: var(--media-slider-value-bg, black);
  border-radius: var(--media-slider-value-border-radius, 2px);
  border: var(--media-slider-value-border);
  color: var(--media-slider-value-color, white);
  padding: var(--media-slider-value-padding, 1px 10px);
}

:where(
    .vds-slider-video:not([data-hidden]) + .vds-slider-chapter-title,
    .vds-slider-thumbnail:not([data-hidden]) + .vds-slider-chapter-title
  ) {
  margin-top: var(--media-slider-chapter-title-gap, 6px);
}

:where(
    .vds-slider-video:not([data-hidden]) + .vds-slider-value,
    .vds-slider-thumbnail:not([data-hidden]) + .vds-slider-value,
    .vds-slider-chapter-title + .vds-slider-value
  ) {
  margin-top: var(--media-slider-value-gap, 2px);
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Vertical Sliders
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-slider[aria-orientation='vertical']) {
  --width: var(--media-slider-width, 48px);
  --height: var(--media-slider-height, 100%);

  --track-width: var(--media-slider-track-width, 4px);
  --track-height: var(--media-slider-track-height, 100%);
  --track-focus-width: var(--media-slider-focused-track-width, calc(var(--track-width) * 1.25));
  --track-focus-height: var(--media-slider-focused-track-height, var(--track-height));

  /** Prevent thumb flowing out of slider. */
  margin: calc(var(--thumb-size) / 2) 0;
}

:where(.vds-slider[aria-orientation='vertical'] .vds-slider-track) {
  top: unset;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%) translateZ(0);
}

:where(.vds-slider[aria-orientation='vertical'] .vds-slider-track-fill) {
  width: var(--track-width);
  height: var(--slider-fill);
  will-change: height;
  transform: translateX(-50%) translateZ(0);
}

:where(.vds-slider[aria-orientation='vertical'] .vds-slider-progress) {
  top: unset;
  bottom: 0;
  width: var(--track-width);
  height: var(--slider-progress, 0%);
  will-change: height;
}

:where(.vds-slider[aria-orientation='vertical'] .vds-slider-thumb) {
  top: unset;
  bottom: var(--slider-fill);
  left: 50%;
  will-change: bottom;
  transform: translate(-50%, 50%) translateZ(0);
}

:where(.vds-slider[aria-orientation='vertical'] .vds-slider-preview) {
  will-change: bottom, opacity;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Time Slider
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where([data-live] .vds-time-slider .vds-slider-track-fill) {
  background-color: var(--media-slider-track-fill-live-bg, #dc2626);
}

:where(.vds-time-slider .vds-slider-progress) {
  z-index: 1; /** above track. */
  left: 0;
  width: var(--slider-progress, 0%);
  will-change: width;
  background-color: var(--media-slider-track-progress-bg, rgb(255 255 255 / 0.5));
}

:where([data-media-player]:not([data-can-play]) .vds-time-slider .vds-slider-value) {
  display: none;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Slider Steps
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-slider-steps) {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

:where(.vds-slider-step) {
  width: var(--media-slider-step-width, 2.5px);
  height: calc(var(--track-height) + 1px);
  background-color: var(--media-slider-step-color, rgb(124, 124, 124));
  opacity: 0;
  transition: opacity 0.3s ease;
}

:where(.vds-slider[data-active] .vds-slider-step) {
  opacity: 1;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Slider Chapters
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-time-slider .vds-slider-chapters) {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  contain: layout style;
  border-radius: var(--media-slider-track-border-radius, 1px);
}

:where(.vds-slider[data-focus], .vds-slider:focus-visible) :where(.vds-slider-chapters) {
  box-shadow: var(--media-focus-ring);
  height: var(--track-height);
}

:where(.vds-time-slider .vds-slider-chapter) {
  margin-right: 2px;
}

:where(.vds-time-slider .vds-slider-chapter:last-child) {
  margin-right: 0;
}

:where(.vds-time-slider .vds-slider-chapter) {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  will-change: height, transform;
  contain: layout style;
  border-radius: var(--media-slider-track-border-radius, 1px);
}

:where(.vds-time-slider .vds-slider-chapter .vds-slider-track-fill) {
  width: var(--chapter-fill, 0%);
  will-change: width;
}

:where(.vds-time-slider .vds-slider-chapter .vds-slider-progress) {
  width: var(--chapter-progress, 0%);
  will-change: width;
}

@media (hover: hover) and (pointer: fine) {
  :where(.vds-time-slider:hover .vds-slider-chapters) {
    contain: strict;
  }

  :where(.vds-time-slider .vds-slider-chapter:hover:not(:only-of-type)) {
    transform: var(--media-slider-chapter-hover-transform, scaleY(2));
    transition: var(
      --media-slider-chapter-hover-transition,
      transform 0.1s cubic-bezier(0.4, 0, 1, 1)
    );
  }
}

:where(.vds-time-slider .vds-slider-chapter-title) {
  font-family: var(--media-font-family, sans-serif);
  font-size: var(--media-slider-chapter-title-font-size, 14px);
  color: var(--media-slider-chapter-title-color, #f5f5f5);
  background-color: var(--media-slider-chapter-title-bg);
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Thumbnail
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-thumbnail) {
  --min-width: var(--media-thumbnail-min-width, 140px);
  --max-width: var(--media-thumbnail-max-width, 180px);
  --aspect-ratio: var(--media-thumbnail-aspect-ratio, var(--thumbnail-aspect-ratio));
  display: block;
  width: var(--thumbnail-width);
  height: var(--thumbnail-height);
  background-color: var(--media-thumbnail-bg, black);
  contain: strict;
  overflow: hidden;
  box-sizing: border-box;
  min-width: var(--min-width);
  min-height: var(--media-thumbnail-min-height, calc(var(--min-width) / var(--aspect-ratio)));
  max-width: var(--max-width);
  max-height: var(--media-thumbnail-max-height, calc(var(--max-width) / var(--aspect-ratio)));
}

.vds-thumbnail {
  border: var(--media-thumbnail-border, 1px solid white);
}

:where(.vds-thumbnail img) {
  min-width: unset !important;
  max-width: unset !important;
  will-change: width, height, transform;
}

:where(.vds-thumbnail[data-loading] img) {
  opacity: 0;
}

:where(.vds-thumbnail[aria-hidden='true']) {
  display: none !important;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Time
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-time-group) {
  display: flex;
  align-items: center;
}

.vds-time-divider {
  margin: 0 var(--media-time-divider-gap, 2.5px);
  color: var(--media-time-divider-color, #e0e0e0);
}

:where(.vds-time) {
  display: inline-block;
  contain: content;
  font-size: var(--media-time-font-size, 15px);
  font-weight: var(--media-time-font-weight, 400);
  font-family: var(--media-font-family, sans-serif);
  border-radius: var(--media-time-border-radius, 2px);
  letter-spacing: var(--media-time-letter-spacing, 0.025em);
}

.vds-time {
  outline: 0;
  color: var(--media-time-color, var(--default-color));
  background-color: var(--media-time-bg);
  border: var(--media-time-border);
  padding: var(--media-time-padding, 2px);
}

:where(.vds-time:focus-visible) {
  box-shadow: var(--media-focus-ring);
}

.light .vds-time {
  --default-color: rgb(10 10 10);
}

.dark .vds-time {
  --default-color: #f5f5f5;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Tooltips
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-tooltip, media-tooltip) {
  display: contents;
}

:where(.vds-tooltip-content) {
  display: inline-block;
  box-sizing: border-box;
  font-family: var(--media-font-family, sans-serif);
  font-size: var(--media-tooltip-font-size, 13px);
  font-weight: var(--media-tooltip-font-weight, 500);
  opacity: 0;
  pointer-events: none;
  white-space: nowrap;
  z-index: 10;
  will-change: transform, opacity;
}

.vds-tooltip-content {
  border-radius: var(--media-tooltip-border-radius, 2px);
  background-color: var(--media-tooltip-bg-color, var(--default-bg));
  border: var(--media-tooltip-border, var(--default-border));
  color: var(--media-tooltip-color, var(--default-color));
  padding: var(--media-tooltip-padding, 2px 8px);
}

.light .vds-tooltip-content {
  --default-color: #1a1a1a;
  --default-bg: white;
  --default-border: 1px solid rgb(0 0 0 / 0.2);
}

.dark .vds-tooltip-content {
  --default-color: #f5f5f5;
  --default-bg: black;
  --default-border: 1px solid rgb(255 255 255 / 0.1);
}

:where(.vds-menu .vds-menu-button[role='button'][data-pressed] .vds-tooltip-content) {
  opacity: 0;
  display: none;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Tooltip Animation
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-tooltip-content) {
  --enter-transform: translateY(0px) scale(1);
  --exit-transform: translateY(12px) scale(0.8);
}

:where(.vds-tooltip-content:not([data-visible])) {
  animation: var(--media-tooltip-exit-animation, vds-tooltip-exit 0.2s ease-out);
}

:where(.vds-tooltip-content[data-visible]) {
  animation: var(--media-tooltip-enter-animation, vds-tooltip-enter 0.2s ease-in);
  animation-fill-mode: forwards;
}

/* Bottom */
:where(.vds-tooltip-content[data-placement~='bottom']) {
  --enter-transform: translateY(0) scale(1);
  --exit-transform: translateY(-12px) scale(0.8);
}

/* Left */
:where(.vds-tooltip-content[data-placement~='left']) {
  --enter-transform: translateX(0) scale(1);
  --exit-transform: translateX(12px) scale(0.8);
}

/* Right */
:where(.vds-tooltip-content[data-placement~='right']) {
  --enter-transform: translateX(0) scale(1);
  --exit-transform: translateX(-12px) scale(0.8);
}

@keyframes vds-tooltip-enter {
  from {
    opacity: 0;
    transform: var(--exit-transform);
  }
  to {
    opacity: 1;
    transform: var(--enter-transform);
  }
}

@keyframes vds-tooltip-exit {
  from {
    opacity: 1;
    transform: var(--enter-transform);
  }
  to {
    opacity: 0;
    transform: var(--exit-transform);
  }
}

@media (prefers-reduced-motion) {
  :where(.vds-tooltip-content) {
    animation: none;
  }

  :where(.vds-tooltip-content[data-visible]) {
    opacity: 1;
  }
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * States
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

/* Play Button */
[data-media-player]:not([data-paused]) .vds-play-tooltip-text,
[data-media-player][data-paused] .vds-pause-tooltip-text,
/* PIP Button */
[data-media-player][data-pip] .vds-pip-enter-tooltip-text,
[data-media-player]:not([data-pip]) .vds-pip-exit-tooltip-text,
/* Fullscreen Button */
[data-media-player][data-fullscreen] .vds-fs-enter-tooltip-text,
[data-media-player]:not([data-fullscreen]) .vds-fs-exit-tooltip-text,
/* Caption Button */
[data-media-player]:not([data-captions]) .vds-cc-on-tooltip-text,
[data-media-player][data-captions] .vds-cc-off-tooltip-text,
/* Mute Button */
[data-media-player]:not([data-muted]) .vds-mute-tooltip-text,
[data-media-player][data-muted] .vds-unmute-tooltip-text {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@vidstack/react/player/styles/default/theme.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;EAIE;;AAEF;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;;EAEE,qBAAqB;EACrB,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;EAIE;;AAEF;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,iEAAiE;AACnE;;AAEA;;EAEE,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;EACE,kDAAkD;EAClD,mDAAmD;EACnD,mDAAmD;AACrD;;AAEA;EACE,kEAAkE;EAClE,wDAAwD;EACxD,wDAAwD;EACxD,qBAAqB;EACrB,+DAA+D;AACjE;;AAEA;EACE,UAAU;EACV,kFAAkF;AACpF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;;;;EAIE;;AAEF;EACE,wCAAwC;EACxC,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,qDAAqD;EACrD,qCAAqC;EACrC,sCAAsC;EACtC,mCAAmC;EACnC,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,wCAAwC;EACxC,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,sEAAsE;EACtE,yCAAyC;AAC3C;;AAEA;EACE,gDAAgD;EAChD,iDAAiD;AACnD;;AAEA;EACE;IACE,mDAAmD;IACnD,oDAAoD;EACtD;AACF;;AAEA;EACE,yCAAyC;EACzC,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,sEAAsE;EACxE;;EAEA;IACE,2DAA2D;IAC3D,wEAAwE;EAC1E;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kEAAkE;IAClE,4EAA4E;EAC9E;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;;;EAIE;;AAEF;EACE,eAAe;EACf,gBAAgB;EAChB,2CAA2C;EAC3C,6CAA6C;EAC7C,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,iDAAiD;EACjD,mDAAmD;EACnD,sDAAsD;EACtD,8DAA8D;EAC9D,2BAA2B;AAC7B;;AAEA;EACE,sDAAsD;EACtD,0DAA0D;EAC1D,8CAA8C;EAC9C,kDAAkD;AACpD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2DAA2D;EAC3D,mDAAmD;AACrD;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;;;;EAIE;;AAEF,gBAAgB;AAChB;;;;;;;;;;;;;;;;;;EAkBE,aAAa;AACf;;AAEA;;;;EAIE;;AAEF;EACE,6EAA6E;EAC7E,oDAAoD;EACpD,wEAAwE;EACxE,kFAAkF;EAClF,4FAA4F;EAC5F,oFAAoF;EACpF,iFAAiF;EACjF,6EAA6E;EAC7E,6EAA6E;EAC7E,wDAAwD;EACxD,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,qBAAqB;EACrB,8BAA8B;EAC9B,+BAA+B;EAC/B,sDAAsD;EACtD,sBAAsB;EACtB,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,2FAA2F;AAC7F;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;;;EAIE;;AAEF;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,6BAA6B;EAC7B,+BAA+B;EAC/B,sBAAsB;EACtB,+BAA+B;EAC/B,iCAAiC;EACjC,4CAA4C;EAC5C,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,2EAA2E;EAC3E,qDAAqD;AACvD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,4CAA4C;EAC5C,sCAAsC;EACtC,kDAAkD;EAClD,qDAAqD;EACrD,mCAAmC;EACnC,sBAAsB;EACtB,8DAA8D;EAC9D,6CAA6C;EAC7C,2BAA2B;EAC3B,kEAAkE;AACpE;;AAEA;EACE,qCAAqC;EACrC,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;;;;EAIE;;AAEF;EACE,sDAAsD;EACtD,+DAA+D;EAC/D,sDAAsD;EACtD,gEAAgE;EAChE,yDAAyD;EACzD,kEAAkE;EAClE,uEAAuE;EACvE,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,eAAe;EACf,gCAAgC;EAChC,2BAA2B;EAC3B,kEAAkE;EAClE,oEAAoE;EACpE,0BAA0B;EAC1B,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;AACA;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,+BAA+B;EAC/B,iCAAiC;EACjC,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mEAAmE;EACnE,qBAAqB;EACrB,iDAAiD;EACjD,qDAAqD;EACrD,wDAAwD;EACxD,mBAAmB;EACnB,SAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sDAAsD;EACtD,qBAAqB;EACrB,2DAA2D;EAC3D,+DAA+D;AACjE;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;;;;EAIE;;AAEF;;EAEE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,sBAAsB;AACxB;;AAEA;;;;EAIE;;AAEF;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;;;EAIE;;AAEF;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,2CAA2C;EAC3C,uEAAuE;AACzE;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,qEAAqE;AACvE;;AAEA;EACE,SAAY;EACZ,oBAAoB;AACtB;;AAEA;;;;EAIE;;AAEF;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;;;;EAIE;;AAEF;EACE,UAAU;AACZ;;AAEA;;;;EAIE;;AAEF;EACE,kBAAkB;EAClB,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,kCAAkC;EAClC,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;EAC1C,iDAAiD;EACjD,0BAA0B;EAC1B,mDAAmD;EACnD,oBAAoB;AACtB;;AAEA;EACE,uDAAuD;EACvD,4DAA4D;EAC5D,gDAAgD;AAClD;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;;;;EAIE;;AAEF;EACE,wCAAwC;EACxC,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;EAC7C,8CAA8C;EAC9C,WAAW;EACX,0BAA0B;EAC1B,6DAA6D;EAC7D,yFAAyF;EACzF,yEAAyE;EACzE,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,QAAQ;EACR,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;;;;EAIE;;AAEF;EACE,uCAAuC;EACvC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;;;;EAIE;;AAEF;EACE,wEAAwE;EACxE,wEAAwE;EACxE,2EAA2E;EAC3E,2EAA2E;EAC3E,2EAA2E;EAC3E,2EAA2E;;EAE3E,+DAA+D;EAC/D,6FAA6F;;EAE7F,mEAAmE;AACrE;;AAEA;EACE,wBAAwB;EACxB,uCAAuC;EACvC,wCAAwC;EACxC,0CAA0C;EAC1C,oCAAoC;EACpC,oCAAoC;;EAEpC,uBAAuB;EACvB,iCAAiC;;EAEjC,oDAAoD;AACtD;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,2CAA2C;EAC3C,uCAAuC;EACvC,iCAAiC;EACjC,iCAAiC;;EAEjC,uBAAuB;EACvB,iCAAiC;;EAEjC,uDAAuD;AACzD;;AAEA;EACE,mDAAmD;EACnD,8CAA8C;EAC9C,iDAAiD;;EAEjD,sDAAsD;EACtD,+CAA+C;EAC/C,0DAA0D;;EAE1D,oEAAoE;;EAEpE,iEAAiE;EACjE,kDAAkD;EAClD,oEAAoE;;EAEpE,iEAAiE;EACjE,yDAAyD;;EAEzD,4EAA4E;;EAE5E,gEAAgE;EAChE,+EAA+E;EAC/E,2EAA2E;;EAE3E,8EAA8E;;EAE9E,oEAAoE;EACpE,uEAAuE;EACvE,uDAAuD;;EAEvD,wDAAwD;;EAExD,+CAA+C;EAC/C,iDAAiD;EACjD,sEAAsE;EACtE,wDAAwD;EACxD,oDAAoD;EACpD,sDAAsD;EACtD,+DAA+D;;EAE/D,uEAAuE;EACvE,gFAAgF;EAChF,4CAA4C;EAC5C,uFAAuF;;EAEvF,mEAAmE;EACnE,mEAAmE;EACnE,mEAAmE;EACnE,kEAAkE;;EAElE,yEAAyE;AAC3E;;AAEA;;;;EAIE;;AAEF;EACE,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;EAME,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;;EAIE;;AAEF;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,sBAAsB;EACtB,6CAA6C;EAC7C,qBAAqB;EACrB,oEAAoE;EACpE,+BAA+B;AACjC;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;EACxC,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;;;;EAIE;;AAEF;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,2DAA2D;EAC3D,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;;;;EAIE;;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,+BAA+B;EAC/B,2BAA2B;EAC3B,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;EACxC,wCAAwC;EACxC,0BAA0B;EAC1B,gCAAgC;EAChC,0BAA0B;EAC1B,gBAAgB;EAChB,4BAA4B;EAC5B,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,+CAA+C;EAC/C;;;GAGC;AACH;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,gFAAgF;AAClF;;AAEA;EACE,sCAAsC;EACtC,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;;;EAIE;;AAEF;EACE,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA,iBAAiB;AACjB;EACE,oCAAoC;AACtC;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;EACE,0EAA0E;EAC1E,6BAA6B;AAC/B;;AAEA,WAAW;AACX;EACE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE;IACE,UAAU;IACV,gCAAgC;EAClC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,UAAU;IACV,iCAAiC;EACnC;EACA;IACE,UAAU;IACV,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,eAAe;IACf,UAAU;EACZ;AACF;;AAEA;;;;EAIE;;AAEF;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,UAAU;EACV,SAAS;EACT,0DAA0D;EAC1D,2DAA2D;AAC7D;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,uEAAuE;IACvE,wEAAwE;EAC1E;AACF;;AAEA;;;;EAIE;;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;;EAIE;;AAEF;EACE,kBAAkB;EAClB,wCAAwC;EACxC,yBAAiB;UAAjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,wCAAwC;EACxC,sBAAsB;EACtB,kCAAkC;EAClC,2BAA2B;EAC3B,aAAa;AACf;;AAEA;;EAEE,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;;;;EAIE,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE;;IAEE,eAAe;IACf,sCAAsC;EACxC;AACF;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iDAAiD;EACjD,kDAAkD;AACpD;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,OAAO;EACP,WAAW;EACX,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;;;EAIE;;AAEF;EACE,SAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA;EACE,+CAA+C;EAC/C,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,iDAAiD;EACjD,oDAAoD;AACtD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,+CAA+C;AACjD;AACA;;;;EAIE;;AAEF;EACE,wDAAwD;EACxD,0DAA0D;EAC1D,6EAA6E;EAC7E;;;GAGC;EACD,qDAAqD;EACrD,kBAAkB;EAClB,qBAAqB;EACrB,4BAA4B;EAC5B,8BAA8B;EAC9B,+CAA+C;EAC/C,gCAAgC;EAChC,sBAAsB;EACtB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,+BAA+B;EAC/B,gCAAgC;EAChC,iDAAiD;EACjD,kBAAkB;EAClB,wBAAwB;EACxB,0CAA0C;EAC1C,gCAAgC;EAChC,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE;;GAEC;AACH;;AAEA;EACE;IACE,kEAAkE;EACpE;AACF;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;;;EAIE;;AAEF;EACE,gFAAgF;EAChF,0FAA0F;EAC1F,4DAA4D;EAC5D,oDAAoD;AACtD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,6BAA6B;AAC/B;;AAEA;;;;EAIE,wBAAwB;EACxB,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;;;;EAIE;;AAEF;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+DAA+D;AACjE;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;EAIE;;AAEF;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;;;EAIE;;AAEF;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kCAAkC;EAClC,2DAA2D;EAC3D,8DAA8D;EAC9D,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,2DAA2D;AAC7D;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;;EAIE;;AAEF;EACE,8EAA8E;AAChF;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kDAAkD;EAClD,kBAAkB;EAClB,SAAS;EACT,OAAO;AACT;;AAEA;EACE,8DAA8D;EAC9D,4CAA4C;AAC9C;;AAEA;EACE,uDAAuD;EACvD,cAAc;EACd,2DAA2D;EAC3D,4DAA4D;EAC5D,2DAA2D;EAC3D,4DAA4D;AAC9D;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,sEAAsE;EACtE,kEAAkE;EAClE,wCAAwC;EACxC,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,0DAA0D;AAC5D;;AAEA;EACE,6BAA6B;EAC7B,wCAAwC;EACxC,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;EACE,4CAA4C;EAC5C,gEAAgE;AAClE;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;;;;EAIE;;AAEF;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,OAAO;EACP,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,sBAAsB;EACtB,iCAAiC;EACjC,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;;EAIE;;AAEF;EACE,wCAAwC;EACxC,0CAA0C;;EAE1C,kDAAkD;EAClD,yFAAyF;;EAEzF,oDAAoD;EACpD,qDAAqD;EACrD,gFAAgF;EAChF,gGAAgG;;EAEhG,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,0CAA0C;EAC1C,qCAAqC;EACrC,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B,QAAQ;EACR,OAAO;EACP,2DAA2D;EAC3D,yCAAyC;EACzC,sEAAsE;EACtE,eAAe;AACjB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,UAAU,EAAE,qCAAqC;EACjD,uEAAuE;EACvE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,wBAAwB;EACxB,UAAU;EACV,0BAA0B;EAC1B,wBAAwB;EACxB,yBAAyB;EACzB,2DAA2D;EAC3D,8DAA8D;EAC9D,oDAAoD;EACpD,8CAA8C;EAC9C,iCAAiC;EACjC,oBAAoB;EACpB,iBAAiB;EACjB,UAAU,EAAE,uBAAuB;AACrC;;AAEA;;EAEE,sFAAsF;AACxF;;AAEA;EACE,UAAU;EACV,4FAA4F;AAC9F;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;;;;EAIE;;AAEF;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;AACnD;;AAEA;;;;EAIE;;AAEF;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;;;EAIE;;AAEF;EACE,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;AACd;;AAEA,0CAA0C;AAC1C;EACE,UAAU;AACZ;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;;;;EAIE;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,gDAAgD;EAChD,6DAA6D;EAC7D,oBAAoB;EACpB,iCAAiC;EACjC,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,qDAAqD;EACrD,2DAA2D;EAC3D,wCAAwC;EACxC,6CAA6C;EAC7C,oDAAoD;AACtD;;AAEA;;;;EAIE,sDAAsD;AACxD;;AAEA;;;;;EAKE,8CAA8C;AAChD;;AAEA;;;;EAIE;;AAEF;EACE,wCAAwC;EACxC,0CAA0C;;EAE1C,mDAAmD;EACnD,sDAAsD;EACtD,6FAA6F;EAC7F,mFAAmF;;EAEnF,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,UAAU;EACV,SAAS;EACT,SAAS;EACT,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,UAAU;EACV,SAAS;EACT,yBAAyB;EACzB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;;;EAIE;;AAEF;EACE,iEAAiE;AACnE;;AAEA;EACE,UAAU,EAAE,kBAAkB;EAC9B,OAAO;EACP,iCAAiC;EACjC,kBAAkB;EAClB,+EAA+E;AACjF;;AAEA;EACE,aAAa;AACf;;AAEA;;;;EAIE;;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,4CAA4C;EAC5C,uCAAuC;EACvC,oEAAoE;EACpE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;;;;EAIE;;AAEF;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,2DAA2D;AAC7D;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,qBAAqB;EACrB,2DAA2D;AAC7D;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iEAAiE;IACjE;;;KAGC;EACH;AACF;;AAEA;EACE,iDAAiD;EACjD,4DAA4D;EAC5D,uDAAuD;EACvD,sDAAsD;AACxD;;AAEA;;;;EAIE;;AAEF;EACE,oDAAoD;EACpD,oDAAoD;EACpD,kFAAkF;EAClF,cAAc;EACd,6BAA6B;EAC7B,+BAA+B;EAC/B,kDAAkD;EAClD,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;EAC3B,2FAA2F;EAC3F,2BAA2B;EAC3B,2FAA2F;AAC7F;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;;EAIE;;AAEF;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;EAC9C,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,4CAA4C;EAC5C,+CAA+C;EAC/C,iDAAiD;EACjD,mDAAmD;EACnD,yDAAyD;AAC3D;;AAEA;EACE,UAAU;EACV,oDAAoD;EACpD,sCAAsC;EACtC,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;;EAIE;;AAEF;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,iDAAiD;EACjD,+CAA+C;EAC/C,kDAAkD;EAClD,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,sDAAsD;EACtD,kEAAkE;EAClE,0DAA0D;EAC1D,uDAAuD;EACvD,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;;;;EAIE;;AAEF;EACE,2CAA2C;EAC3C,6CAA6C;AAC/C;;AAEA;EACE,8EAA8E;AAChF;;AAEA;EACE,+EAA+E;EAC/E,6BAA6B;AAC/B;;AAEA,WAAW;AACX;EACE,yCAAyC;EACzC,8CAA8C;AAChD;;AAEA,SAAS;AACT;EACE,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA,UAAU;AACV;EACE,yCAAyC;EACzC,8CAA8C;AAChD;;AAEA;EACE;IACE,UAAU;IACV,gCAAgC;EAClC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,UAAU;IACV,iCAAiC;EACnC;EACA;IACE,UAAU;IACV,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;;;;EAIE;;AAEF,gBAAgB;AAChB;;;;;;;;;;;;;;EAcE,aAAa;AACf","sourcesContent":["/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Player\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n[data-media-player] {\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  position: relative;\n  contain: style;\n  box-sizing: border-box;\n  user-select: none;\n}\n\n[data-media-player] * {\n  box-sizing: border-box;\n}\n\n:where([data-media-player][data-view-type='video']) {\n  aspect-ratio: 16 / 9;\n}\n\n[data-media-player]:focus,\n[data-media-player]:focus-visible {\n  outline: none;\n}\n\n[data-media-player][data-view-type='video'][data-started]:not([data-controls]) {\n  pointer-events: auto;\n  cursor: none;\n}\n\n[data-media-player] slot {\n  display: contents;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Provider\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n[data-media-provider] {\n  display: flex;\n  position: relative;\n  box-sizing: border-box;\n  align-items: center;\n  border-radius: inherit;\n  width: 100%;\n  aspect-ratio: inherit;\n  overflow: hidden;\n}\n\n[data-media-player]:not([data-view-type='audio']) [data-media-provider],\n[data-media-player][data-fullscreen] [data-media-provider] {\n  height: 100%;\n}\n\n[data-media-player][data-view-type='audio'] [data-media-provider] {\n  display: contents;\n  background-color: unset;\n}\n\n[data-media-provider] audio {\n  width: 100%;\n}\n\n:where(video:not([width]):not([height]), iframe:not([width]):not([height])) {\n  width: 100%;\n  aspect-ratio: 16 / 9;\n}\n\n:where([data-media-provider] video),\n:where([data-media-provider] iframe) {\n  aspect-ratio: inherit;\n  display: inline-block;\n  height: auto;\n  object-fit: contain;\n  touch-action: manipulation;\n  border-radius: inherit;\n  width: 100%;\n}\n\n[data-media-provider] iframe {\n  height: 100%;\n}\n\n[data-media-player][data-view-type='audio'] video,\n[data-media-player][data-view-type='audio'] iframe {\n  display: none;\n}\n\n[data-media-player][data-fullscreen] video {\n  height: 100%;\n}\n\n[data-media-provider] iframe:not([src]) {\n  display: none;\n}\n\niframe.vds-youtube[data-no-controls] {\n  height: 1000%;\n}\n\n.vds-blocker {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: auto;\n  aspect-ratio: inherit;\n  pointer-events: auto;\n  border-radius: inherit;\n  z-index: 1;\n}\n\n[data-ended] .vds-blocker {\n  background-color: black;\n}\n\n.vds-icon:focus {\n  outline: none;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Google Cast\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n.vds-google-cast {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  color: #dedede;\n  font-family: sans-serif;\n  font-weight: 500;\n}\n\n.vds-google-cast svg {\n  --size: max(18%, 40px);\n  width: var(--size);\n  height: var(--size);\n  margin-bottom: 8px;\n}\n\n.vds-google-cast-info {\n  font-size: calc(var(--media-height) / 100 * 6);\n}\n\n:where(.vds-buffering-indicator) {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n  z-index: 1;\n}\n\n:where(.vds-buffering-indicator) :where(.vds-buffering-icon, .vds-buffering-spinner) {\n  opacity: 0;\n  pointer-events: none;\n  transition: var(--media-buffering-transition, opacity 200ms ease);\n}\n\n:where(.vds-buffering-indicator)\n  :where(.vds-buffering-icon, svg.vds-buffering-spinner, .vds-buffering-spinner svg) {\n  width: var(--media-buffering-size, 96px);\n  height: var(--media-buffering-size, 96px);\n}\n\n:where(.vds-buffering-indicator) :where(.vds-buffering-track, circle[data-part='track']) {\n  color: var(--media-buffering-track-color, #f5f5f5);\n  opacity: var(--media-buffering-track-opacity, 0.25);\n  stroke-width: var(--media-buffering-track-width, 8);\n}\n\n:where(.vds-buffering-indicator) :where(.vds-buffering-track-fill, circle[data-part='track-fill']) {\n  color: var(--media-buffering-track-fill-color, var(--media-brand));\n  opacity: var(--media-buffering-track-fill-opacity, 0.75);\n  stroke-width: var(--media-buffering-track-fill-width, 9);\n  stroke-dasharray: 100;\n  stroke-dashoffset: var(--media-buffering-track-fill-offset, 50);\n}\n\n:where([data-buffering]) :where(.vds-buffering-icon, .vds-buffering-spinner) {\n  opacity: 1;\n  animation: var(--media-buffering-animation, vds-buffering-spin 1s linear infinite);\n}\n\n@keyframes vds-buffering-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media (prefers-reduced-motion) {\n  :where([data-buffering]) :where(.vds-buffering-icon, .vds-buffering-spinner) {\n    animation-duration: 8s;\n  }\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Buttons\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-button) {\n  -webkit-tap-highlight-color: transparent;\n  position: relative;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  user-select: none;\n  appearance: none;\n  background: none;\n  outline: none;\n  border: none;\n  border-radius: var(--media-button-border-radius, 8px);\n  width: var(--media-button-size, 40px);\n  height: var(--media-button-size, 40px);\n  transition: transform 0.2s ease-out;\n  contain: layout style;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -webkit-tap-highlight-color: transparent;\n  touch-action: manipulation;\n  flex-shrink: 0;\n}\n\n.vds-button {\n  border: var(--media-button-border);\n  color: var(--media-button-color, var(--media-controls-color, #f5f5f5));\n  padding: var(--media-button-padding, 0px);\n}\n\n:where([data-fullscreen] .vds-button) {\n  width: var(--media-fullscreen-button-size, 42px);\n  height: var(--media-fullscreen-button-size, 42px);\n}\n\n@media screen and (max-width: 599px) {\n  :where([data-fullscreen] .vds-button) {\n    width: var(--media-sm-fullscreen-button-size, 42px);\n    height: var(--media-sm-fullscreen-button-size, 42px);\n  }\n}\n\n:where(.vds-button .vds-icon) {\n  width: var(--media-button-icon-size, 80%);\n  height: var(--media-button-icon-size, 80%);\n  border-radius: var(--media-button-border-radius, 8px);\n}\n\n:where(.vds-menu-button .vds-icon) {\n  display: flex !important;\n}\n\n:where(.vds-button[aria-hidden='true']) {\n  display: none !important;\n}\n\n@media (hover: hover) and (pointer: fine) {\n  .vds-button:hover {\n    background-color: var(--media-button-hover-bg, rgb(255 255 255 / 0.2));\n  }\n\n  .vds-button:hover {\n    transform: var(--media-button-hover-transform, scale(1.05));\n    transition: var(--media-button-hover-transition, transform 0.2s ease-in);\n  }\n\n  .vds-button[aria-expanded='true'] {\n    transform: unset;\n  }\n}\n\n@media (pointer: coarse) {\n  .vds-button:hover {\n    border-radius: var(--media-button-touch-hover-border-radius, 100%);\n    background-color: var(--media-button-touch-hover-bg, rgb(255 255 255 / 0.2));\n  }\n}\n\n:where(.vds-button:focus) {\n  outline: none;\n}\n\n:where(.vds-button[data-focus], .vds-button:focus-visible) {\n  box-shadow: var(--media-focus-ring);\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Live Button\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-live-button) {\n  min-width: auto;\n  min-height: auto;\n  width: var(--media-live-button-width, 40px);\n  height: var(--media-live-button-height, 40px);\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  user-select: none;\n  appearance: none;\n  background: none;\n  outline: none;\n  border: none;\n}\n\n:where(.vds-live-button-text) {\n  font-family: var(--media-font-family, sans-serif);\n  font-size: var(--media-live-button-font-size, 12px);\n  font-weight: var(--media-live-button-font-weight, 600);\n  letter-spacing: var(--media-live-button-letter-spacing, 1.5px);\n  transition: color 0.3s ease;\n}\n\n.vds-live-button-text {\n  background-color: var(--media-live-button-bg, #8a8a8a);\n  border-radius: var(--media-live-button-border-radius, 2px);\n  color: var(--media-live-button-color, #161616);\n  padding: var(--media-live-button-padding, 1px 4px);\n}\n\n:where(.vds-live-button[data-focus] .vds-live-button-text) {\n  box-shadow: var(--media-focus-ring);\n}\n\n:where(.vds-live-button[data-edge]) {\n  cursor: unset;\n}\n\n.vds-live-button[data-edge] .vds-live-button-text {\n  background-color: var(--media-live-button-edge-bg, #dc2626);\n  color: var(--media-live-button-edge-color, #f5f5f5);\n}\n\n@media (pointer: fine) {\n  :where(.vds-live-button:hover) {\n    background-color: unset;\n  }\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * States\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n/* Play Button */\n.vds-button:not([data-paused]) .vds-play-icon,\n.vds-button[data-ended] .vds-play-icon,\n.vds-button[data-paused] .vds-pause-icon,\n.vds-button[data-ended] .vds-pause-icon,\n.vds-button:not([data-ended]) .vds-replay-icon,\n/* PIP Button */\n.vds-button[data-active] .vds-pip-enter-icon,\n.vds-button:not([data-active]) .vds-pip-exit-icon,\n/* Fullscreen Button */\n.vds-button[data-active] .vds-fs-enter-icon,\n.vds-button:not([data-active]) .vds-fs-exit-icon,\n/* Caption Button */\n.vds-button:not([data-active]) .vds-cc-on-icon,\n.vds-button[data-active] .vds-cc-off-icon,\n/* Mute Button */\n.vds-button:not([data-muted]) .vds-mute-icon,\n.vds-button:not([data-state='low']) .vds-volume-low-icon,\n.vds-button:not([data-state='high']) .vds-volume-high-icon {\n  display: none;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Captions\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-captions) {\n  /* Recommended settings in the WebVTT spec (https://www.w3.org/TR/webvtt1). */\n  --overlay-padding: var(--media-captions-padding, 1%);\n  --cue-color: var(--media-user-text-color, var(--media-cue-color, white));\n  --cue-bg-color: var(--media-user-text-bg, var(--media-cue-bg, rgba(0, 0, 0, 0.7)));\n  --cue-default-font-size: var(--media-cue-font-size, calc(var(--overlay-height) / 100 * 4.5));\n  --cue-font-size: calc(var(--cue-default-font-size) * var(--media-user-font-size, 1));\n  --cue-line-height: var(--media-cue-line-height, calc(var(--cue-font-size) * 1.2));\n  --cue-padding-x: var(--media-cue-padding-x, calc(var(--cue-font-size) * 0.6));\n  --cue-padding-y: var(--media-cue-padding-x, calc(var(--cue-font-size) * 0.4));\n  --cue-padding: var(--cue-padding-y) var(--cue-padding-x);\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  contain: layout style;\n  margin: var(--overlay-padding);\n  font-size: var(--cue-font-size);\n  font-family: var(--media-user-font-family, sans-serif);\n  box-sizing: border-box;\n  pointer-events: none;\n  user-select: none;\n  word-spacing: normal;\n  word-break: break-word;\n}\n\n:where([data-fullscreen][data-orientation='portrait'] .vds-captions) {\n  --cue-default-font-size: var(--media-cue-font-size, calc(var(--overlay-width) / 100 * 4.5));\n}\n\n:where([data-view-type='audio'] .vds-captions) {\n  position: relative;\n  margin: 0;\n}\n\n:where(.vds-captions[aria-hidden='true']) {\n  opacity: 0;\n  visibility: hidden;\n}\n\n.vds-captions[data-example] {\n  opacity: 1 !important;\n  visibility: visible !important;\n}\n\n:where([data-view-type='video'] .vds-captions [data-part='cue-display'][data-example]) {\n  --cue-text-align: center;\n  --cue-width: 100%;\n  --cue-top: 90%;\n  --cue-left: 0%;\n}\n\n:where([data-view-type='audio'] .vds-captions [data-part='cue-display']) {\n  --cue-width: 100%;\n  position: relative !important;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * VTT Cues\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-captions [data-part='cue-display']) {\n  position: absolute;\n  direction: ltr;\n  overflow: visible;\n  contain: content;\n  top: var(--cue-top);\n  left: var(--cue-left);\n  right: var(--cue-right);\n  bottom: var(--cue-bottom);\n  width: var(--cue-width, auto);\n  height: var(--cue-height, auto);\n  box-sizing: border-box;\n  transform: var(--cue-transform);\n  text-align: var(--cue-text-align);\n  writing-mode: var(--cue-writing-mode, unset);\n  white-space: pre-line;\n  unicode-bidi: plaintext;\n  min-width: min-content;\n  min-height: min-content;\n  background-color: var(--media-user-display-bg, var(--media-cue-display-bg));\n  border-radius: var(--media-cue-display-border-radius);\n}\n\n.vds-captions [data-part='cue-display'] {\n  padding: var(--media-cue-display-padding);\n}\n\n:where(.vds-captions[data-dir='rtl'] [data-part='cue-display']) {\n  direction: rtl;\n}\n\n:where(.vds-captions [data-part='cue']) {\n  display: inline-block;\n  contain: content;\n  font-variant: var(--media-user-font-variant);\n  border: var(--media-cue-border, unset);\n  border-radius: var(--media-cue-border-radius, 2px);\n  backdrop-filter: var(--media-cue-backdrop, blur(8px));\n  line-height: var(--cue-line-height);\n  box-sizing: border-box;\n  box-shadow: var(--media-cue-box-shadow, var(--cue-box-shadow));\n  white-space: var(--cue-white-space, pre-wrap);\n  outline: var(--cue-outline);\n  text-shadow: var(--media-user-text-shadow, var(--cue-text-shadow));\n}\n\n.vds-captions [data-part='cue'] {\n  background-color: var(--cue-bg-color);\n  color: var(--cue-color);\n  padding: var(--cue-padding);\n}\n\n:where(.vds-captions [data-part='cue-display'][data-vertical] [data-part='cue']) {\n  --cue-padding: var(--cue-padding-x) var(--cue-padding-y);\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * VTT Regions\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-captions [data-part='region']) {\n  --anchor-x-percent: calc(var(--region-anchor-x) / 100);\n  --anchor-x: calc(var(--region-width) * var(--anchor-x-percent));\n  --anchor-y-percent: calc(var(--region-anchor-y) / 100);\n  --anchor-y: calc(var(--region-height) * var(--anchor-y-percent));\n  --vp-anchor-x: calc(var(--region-viewport-anchor-x) * 1%);\n  --vp-anchor-y-percent: calc(var(--region-viewport-anchor-y) / 100);\n  --vp-anchor-y: calc(var(--overlay-height) * var(--vp-anchor-y-percent));\n  position: absolute;\n  display: inline-flex;\n  flex-flow: column;\n  justify-content: flex-start;\n  width: var(--region-width);\n  height: var(--region-height);\n  min-height: 0px;\n  max-height: var(--region-height);\n  writing-mode: horizontal-tb;\n  top: var(--region-top, calc(var(--vp-anchor-y) - var(--anchor-y)));\n  left: var(--region-left, calc(var(--vp-anchor-x) - var(--anchor-x)));\n  right: var(--region-right);\n  bottom: var(--region-bottom);\n  overflow: hidden;\n  overflow-wrap: break-word;\n  box-sizing: border-box;\n}\n\n:where(.vds-captions [data-part='region'][data-active]) {\n}\n\n:where(.vds-captions [data-part='region'][data-scroll='up']) {\n  justify-content: end;\n}\n\n:where(.vds-captions [data-part='region'][data-active][data-scroll='up']) {\n  transition: top 0.433s;\n}\n\n:where(.vds-captions [data-part='region'] > [data-part='cue-display']) {\n  position: relative;\n  width: auto;\n  left: var(--cue-offset);\n  height: var(--cue-height, auto);\n  text-align: var(--cue-text-align);\n  unicode-bidi: plaintext;\n  margin-top: 2px;\n}\n\n:where(.vds-captions [data-part='region'] [data-part='cue']) {\n  position: relative;\n  border-radius: 0px;\n}\n\n:where(.vds-chapter-title) {\n  --color: var(--media-chapter-title-color, rgba(255 255 255 / 0.64));\n  display: inline-block;\n  font-family: var(--media-font-family, sans-serif);\n  font-size: var(--media-chapter-title-font-size, 16px);\n  font-weight: var(--media-chapter-title-font-weight, 400);\n  color: var(--color);\n  flex: 1 1 0%;\n  padding-inline: 6px;\n  overflow: hidden;\n  text-align: start;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.vds-chapter-title::before {\n  content: var(--media-chapter-title-separator, '\\2022');\n  display: inline-block;\n  margin-right: var(--media-chapter-title-separator-gap, 6px);\n  color: var(--media-chapter-title-separator-color, var(--color));\n}\n\n.vds-chapter-title:empty::before {\n  content: '';\n  margin: 0;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Controls\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-controls),\n:where(.vds-controls-group) {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Audio Controls\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where([data-view-type='audio'] .vds-controls) {\n  display: inline-block;\n  max-width: 100%;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Video Controls\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where([data-view-type='video'] .vds-controls) {\n  display: flex;\n  position: absolute;\n  flex-direction: column;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 10;\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  padding: var(--media-controls-padding, 0px);\n  transition: var(--media-controls-out-transition, opacity 0.2s ease-out);\n}\n\n:where([data-view-type='video'] .vds-controls[data-visible]) {\n  opacity: 1;\n  visibility: visible;\n  transition: var(--media-controls-in-transition, opacity 0.2s ease-in);\n}\n\n:where(.vds-controls-spacer) {\n  flex: 1 1 0%;\n  pointer-events: none;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Gesture\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-gestures) {\n  display: contents;\n}\n\n:where(.vds-gesture) {\n  position: absolute;\n  display: block;\n  contain: content;\n  z-index: 0;\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none !important;\n}\n\n:where(.vds-icon svg) {\n  display: block;\n  width: 100%;\n  height: 100%;\n  vertical-align: middle;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Keyboard Action\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-kb-action.hidden) {\n  opacity: 0;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Keyboard Text\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-kb-text-wrapper) {\n  text-align: center;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: var(--media-kb-text-top, 10%);\n  z-index: 20;\n  pointer-events: none;\n}\n\n:where(.vds-kb-text) {\n  display: inline-block;\n  font-size: var(--media-kb-text-size, 150%);\n  font-family: var(--media-font-family, sans-serif);\n  backdrop-filter: blur(2px);\n  border-radius: var(--media-kb-border-radius, 2.5px);\n  pointer-events: none;\n}\n\n.vds-kb-text {\n  color: var(--media-kb-text-color, var(--default-color));\n  background-color: var(--media-kb-text-bg, var(--default-bg));\n  padding: var(--media-kb-text-padding, 10px 20px);\n}\n\n.light .vds-kb-text {\n  --default-color: #1a1a1a;\n  --default-bg: rgb(240 240 240 / 0.6);\n}\n\n.dark .vds-kb-text {\n  --default-color: #f5f5f5;\n  --default-bg: rgb(10 10 10 / 0.6);\n}\n\n:where(.vds-kb-text:empty) {\n  display: none;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Keyboard Bezel\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-kb-bezel) {\n  --size: var(--media-kb-bezel-size, 52px);\n  position: absolute;\n  left: 50%;\n  top: 45%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: var(--size);\n  height: var(--size);\n  margin-left: calc(-1 * calc(var(--size) / 2));\n  margin-right: calc(-1 * calc(var(--size) / 2));\n  z-index: 20;\n  backdrop-filter: blur(2px);\n  background-color: var(--media-kb-bezel-bg, var(--default-bg));\n  animation: var(--media-kb-bezel-animation, vds-bezel-fade 0.35s linear 1 normal forwards);\n  border-radius: var(--media-kb-bezel-border-radius, calc(var(--size) / 2));\n  pointer-events: none;\n}\n\n.vds-kb-bezel:not(:has(svg)) {\n  display: none !important;\n}\n\n.light .vds-kb-bezel {\n  --default-bg: rgb(255 255 255 / 0.6);\n}\n\n.dark .vds-kb-bezel {\n  --default-bg: rgb(10 10 10 / 0.6);\n}\n\n@media (prefers-reduced-motion) {\n  :where(.vds-kb-bezel) {\n    animation: none;\n  }\n}\n\n:where(.vds-kb-bezel:has(slot:empty)) {\n  opacity: 0;\n}\n\n:where(.vds-kb-action[data-action='seek-forward'] .vds-kb-bezel) {\n  top: 45%;\n  left: unset;\n  right: 10%;\n}\n\n:where(.vds-kb-action[data-action='seek-backward'] .vds-kb-bezel) {\n  top: 45%;\n  left: 10%;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Keyboard Icon\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-kb-icon) {\n  --size: var(--media-kb-icon-size, 38px);\n  width: var(--size);\n  height: var(--size);\n}\n\n.vds-kb-icon {\n  color: var(--media-kb-icon-color, var(--default-color));\n}\n\n.light .vds-kb-icon {\n  --default-color: #1a1a1a;\n}\n\n.dark .vds-kb-icon {\n  --default-color: #f5f5f5;\n}\n\n@keyframes vds-bezel-fade {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n    transform: scale(2);\n  }\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Theme\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-menu-items) {\n  --color-inverse: var(--media-menu-color-inverse, var(--default-inverse));\n  --color-gray-50: var(--media-menu-color-gray-50, var(--default-gray-50));\n  --color-gray-100: var(--media-menu-color-gray-100, var(--default-gray-100));\n  --color-gray-200: var(--media-menu-color-gray-200, var(--default-gray-200));\n  --color-gray-300: var(--media-menu-color-gray-300, var(--default-gray-300));\n  --color-gray-400: var(--media-menu-color-gray-400, var(--default-gray-400));\n\n  --text-color: var(--media-menu-text-color, var(--default-text));\n  --text-secondary-color: var(--media-menu-text-secondary-color, var(--default-text-secondary));\n\n  --root-border: var(--media-menu-border, var(--default-root-border));\n}\n\n.light .vds-menu-items {\n  --default-inverse: black;\n  --default-gray-50: rgb(80 80 80 / 0.15);\n  --default-gray-100: rgb(80 80 80 / 0.45);\n  --default-gray-200: rgb(235 235 235 / 0.6);\n  --default-gray-300: rgb(238 238 238);\n  --default-gray-400: rgb(250 250 250);\n\n  --default-text: #1a1a1a;\n  --default-text-secondary: #6b6b6b;\n\n  --default-root-border: 1px solid rgb(10 10 10 / 0.1);\n}\n\n.dark .vds-menu-items {\n  --default-inverse: white;\n  --default-gray-50: rgb(245 245 245 / 0.1);\n  --default-gray-100: rgb(245 245 245 / 0.45);\n  --default-gray-200: rgb(10 10 10 / 0.6);\n  --default-gray-300: rgb(27 27 27);\n  --default-gray-400: rgb(10 10 10);\n\n  --default-text: #f5f5f5;\n  --default-text-secondary: #8a8a8a;\n\n  --default-root-border: 1px solid rgb(255 255 255 / 0.1);\n}\n\n:where(.vds-menu-items) {\n  --font-family: var(--media-font-family, sans-serif);\n  --font-size: var(--media-menu-font-size, 14px);\n  --font-weight: var(--media-menu-font-weight, 500);\n\n  --root-bg: var(--media-menu-bg, var(--color-gray-400));\n  --root-padding: var(--media-menu-padding, 12px);\n  --root-border-radius: var(--media-menu-border-radius, 4px);\n\n  --divider: var(--media-menu-divider, 1px solid var(--color-gray-50));\n\n  --section-bg: var(--media-menu-section-bg, var(--color-gray-300));\n  --section-border: var(--media-menu-section-border);\n  --section-divider: var(--media-menu-section-divider, var(--divider));\n\n  --top-bar-bg: var(--media-menu-top-bar-bg, var(--color-gray-200));\n  --top-bar-divider: var(--media-menu-divider, transparent);\n\n  --text-hint-color: var(--media-menu-hint-color, var(--text-secondary-color));\n\n  --chapter-divider: var(--media-chapters-divider, var(--divider));\n  --chapter-active-bg: var(--media-chapters-item-active-bg, var(--color-gray-50));\n  --chapter-active-border-left: var(--media-chapters-item-active-border-left);\n\n  --chapter-progress-bg: var(--media-chapters-progress-bg, var(--color-inverse));\n\n  --chapter-time-font-size: var(--media-chapters-time-font-size, 12px);\n  --chapter-time-font-weight: var(--media-chapters-time-font-weight, 500);\n  --chapter-time-gap: var(--media-chapters-time-gap, 6px);\n\n  --chapter-duration-bg: var(--media-chapters-duration-bg);\n\n  --item-border: var(--media-menu-item-border, 0);\n  --item-bg: var(--media-menu-item-bg, transparent);\n  --item-hover-bg: var(--media-menu-item-hover-bg, var(--color-gray-50));\n  --item-icon-size: var(--media-menu-item-icon-size, 18px);\n  --item-padding: var(--media-menu-item-padding, 10px);\n  --item-min-height: var(--media-menu-item-height, 40px);\n  --item-border-radius: var(--media-menu-item-border-radius, 2px);\n\n  --scrollbar-track-bg: var(--media-menu-scrollbar-track-bg, transparent);\n  --scrollbar-thumb-bg: var(--media-menu-scrollbar-thumb-bg, var(--color-gray-50));\n  --webkit-scrollbar-bg: var(--color-gray-400);\n  --webkit-scrollbar-track-bg: var(--media-menu-scrollbar-track-bg, var(--color-gray-50));\n\n  --checkbox-bg: var(--media-menu-checkbox-bg, var(--color-gray-100));\n  --checkbox-active-bg: var(--media-menu-checkbox-bg-active, #1ba13f);\n  --checkbox-handle-bg: var(--media-menu-checkbox-handle-bg, #f5f5f5);\n  --checkbox-handle-border: var(--media-menu-checkbox-handle-border);\n\n  --radio-icon-color: var(--media-menu-radio-icon-color, var(--text-color));\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Menu\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-menu[data-root] media-menu[data-root]) {\n  display: contents;\n}\n\n:where(.vds-menu) {\n  font-family: var(--font-family);\n  font-size: var(--font-size);\n  font-weight: var(--font-weight);\n}\n\n:where(.vds-menu[data-disabled][data-root]) {\n  display: none;\n}\n\n:where(.vds-menu[data-submenu]) {\n  display: inline-block;\n}\n\n:where(.vds-menu-items:focus) {\n  outline: none;\n}\n\n:where(.vds-menu-item:focus, .vds-radio:focus) {\n  outline: none;\n}\n\n:where(\n    .vds-menu-item:focus-visible,\n    .vds-menu-item[data-focus],\n    .vds-radio:focus-visible,\n    .vds-radio[data-focus]\n  ) {\n  outline: none;\n  box-shadow: var(--media-focus-ring);\n}\n\n:where(.vds-menu[data-open] .vds-tooltip-content) {\n  display: none !important;\n}\n\n.vds-menu-items [data-hidden] {\n  display: none !important;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Scroll\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n@media (prefers-reduced-motion: no-preference) {\n  :where(.vds-menu-items) {\n    scroll-behavior: smooth;\n  }\n}\n\n:where(.vds-menu-items) {\n  box-sizing: border-box;\n  min-width: var(--media-menu-min-width, 280px);\n  scrollbar-width: thin;\n  scrollbar-color: var(--scrollbar-thumb-bg) var(--scrollbar-track-bg);\n  transform: translate3d(0, 0, 0);\n}\n\n:where(.vds-menu-items)::-webkit-scrollbar {\n  background-color: var(--webkit-scrollbar-bg);\n  border-radius: var(--root-border-radius);\n  height: 6px;\n  width: 5px;\n}\n\n:where(.vds-menu-items)::-webkit-scrollbar-track {\n  background-color: var(--webkit-scrollbar-track-bg);\n  border-radius: 4px;\n}\n\n:where(.vds-menu-items)::-webkit-scrollbar-thumb {\n  background-color: var(--scrollbar-thumb-bg);\n  border-radius: 4px;\n}\n\n:where(.vds-menu-items)::-webkit-scrollbar-corner {\n  background-color: var(--scrollbar-thumb-bg);\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Menu Button\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-menu-button) {\n  outline: none;\n  box-sizing: border-box;\n}\n\n:where(.vds-menu-button .vds-rotate-icon) {\n  transition: transform 0.2s ease-out;\n}\n\n:where(.vds-menu-button[aria-expanded='true'] .vds-rotate-icon) {\n  transform: rotate(var(--media-menu-icon-rotate-deg, 90deg));\n  transition: transform 0.2s ease-in;\n}\n\n:where(.vds-menu-button) {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n@media (prefers-reduced-motion) {\n  :where(.vds-menu-button .vds-rotate-icon) {\n    transition: unset;\n  }\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Menu Items\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-menu-items) {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  font-family: var(--font-family);\n  font-size: var(--font-size);\n  font-weight: var(--font-weight);\n  transition: height 0.35s ease;\n}\n\n@media (prefers-reduced-motion) {\n  :where(.vds-menu-items) {\n    transition: unset;\n  }\n}\n\n:where(.vds-menu-items[data-root]) {\n  background-color: var(--root-bg);\n  border-radius: var(--root-border-radius);\n  box-shadow: var(--media-menu-box-shadow);\n  backdrop-filter: blur(4px);\n  height: var(--menu-height, auto);\n  will-change: width, height;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  opacity: 0;\n  z-index: 9999999;\n  box-sizing: border-box;\n  max-height: var(--media-menu-max-height, 250px);\n  filter: var(\n    --media-menu-filter,\n    drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06))\n  );\n}\n\n.vds-menu-items[data-root] {\n  border: var(--root-border);\n  padding: var(--root-padding);\n}\n\n:where([data-view-type='video']) :where(.vds-menu-items[data-root]) {\n  max-height: var(--media-menu-video-max-height, calc(var(--player-height) * 0.7));\n}\n\n:where(.vds-menu-items[data-transition='height']) {\n  --scrollbar-thumb-bg: rgba(0, 0, 0, 0);\n  pointer-events: none;\n  overflow: hidden;\n}\n\n.vds-menu-button[aria-disabled='true'],\n.vds-menu-item[aria-disabled='true'],\n.vds-menu-item[data-disabled] {\n  display: none;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Menu Items Animation\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-menu-items[data-root]) {\n  --enter-transform: translateY(0px);\n  --exit-transform: translateY(12px);\n}\n\n/* Mobile Popup */\n:where(.vds-menu-items[data-root]:not([data-placement])) {\n  --enter-transform: translateY(-24px);\n}\n\n:where(.vds-menu-items[data-root][aria-hidden='true']) {\n  animation: var(--media-menu-exit-animation, vds-menu-exit 0.2s ease-out);\n}\n\n:where(.vds-menu-items[data-root][aria-hidden='false']) {\n  animation: var(--media-menu-enter-animation, vds-menu-enter 0.3s ease-out);\n  animation-fill-mode: forwards;\n}\n\n/* Bottom */\n:where(.vds-menu-items[data-placement~='bottom']) {\n  --enter-transform: translateY(0);\n  --exit-transform: translateY(-12px);\n}\n\n@keyframes vds-menu-enter {\n  from {\n    opacity: 0;\n    transform: var(--exit-transform);\n  }\n  to {\n    opacity: 1;\n    transform: var(--enter-transform);\n  }\n}\n\n@keyframes vds-menu-exit {\n  from {\n    opacity: 1;\n    transform: var(--enter-transform);\n  }\n  to {\n    opacity: 0;\n    transform: var(--exit-transform);\n  }\n}\n\n@media (prefers-reduced-motion) {\n  :where(.vds-menu-items) {\n    animation: none;\n    opacity: 1;\n  }\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Menu Portal\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(media-menu-portal) {\n  display: contents;\n}\n\n:where(.vds-menu-items[data-root]:not([data-placement])) {\n  position: fixed;\n  left: 16px;\n  right: 16px;\n  top: unset;\n  bottom: 0;\n  max-height: var(--media-sm-menu-portrait-max-height, 40vh);\n  max-height: var(--media-sm-menu-portrait-max-height, 40dvh);\n}\n\n:where(.vds-menu-items[data-root]:not([data-placement])) {\n  max-width: 480px;\n  margin: 0 auto;\n}\n\n@media (orientation: landscape) and (pointer: coarse) {\n  :where(.vds-menu-items[data-root]:not([data-placement])) {\n    max-height: var(--media-sm-menu-landscape-max-height, min(70vh, 400px));\n    max-height: var(--media-sm-menu-landscape-max-height, min(70dvh, 400px));\n  }\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Submenu\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-menu[data-submenu] .vds-menu-button) {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n:where(.vds-menu-items[data-submenu]) {\n  width: 100%;\n}\n\n:where(.vds-menu[aria-hidden='true']),\n:where(.vds-menu-items[data-submenu][aria-hidden='true']) {\n  display: none;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Menu Item\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-menu-item, .vds-radio) {\n  position: relative;\n  -webkit-tap-highlight-color: transparent;\n  user-select: none;\n  display: flex;\n  align-items: center;\n  justify-content: left;\n  width: 100%;\n  appearance: none;\n  border: 0;\n  border-radius: var(--item-border-radius);\n  box-sizing: border-box;\n  min-height: var(--item-min-height);\n  font-size: var(--font-size);\n  outline: none;\n}\n\n.vds-menu-item,\n.vds-radio {\n  color: var(--text-color);\n  background-color: var(--item-bg);\n  padding: var(--item-padding);\n}\n\n.vds-menu-item:focus-visible,\n.vds-menu-item[data-focus],\n.vds-radio:focus-visible,\n.vds-radio[data-focus] {\n  cursor: pointer;\n  background-color: var(--item-hover-bg);\n}\n\n@media (hover: hover) and (pointer: fine) {\n  .vds-menu-item[role]:hover,\n  .vds-radio:hover {\n    cursor: pointer;\n    background-color: var(--item-hover-bg);\n  }\n}\n\n:where(.vds-menu-items[data-submenu]) {\n  align-items: flex-start;\n  justify-content: center;\n  flex-direction: column;\n}\n\n:where(.vds-menu-item[aria-expanded='true']) {\n  font-weight: bold;\n  border-radius: 0;\n  border-top-left-radius: var(--item-border-radius);\n  border-top-right-radius: var(--item-border-radius);\n}\n\n.vds-menu-item[aria-expanded='true'] {\n  border-bottom: var(--top-bar-divider);\n}\n\n:where(.vds-menu-item[aria-expanded='true']) {\n  position: sticky;\n  top: calc(-1 * var(--root-padding));\n  left: 0;\n  width: 100%;\n  z-index: 10;\n  backdrop-filter: blur(4px);\n  margin-bottom: 4px;\n}\n\n.vds-menu-item[aria-expanded='true'] {\n  background-color: var(--top-bar-bg);\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Menu Item Parts\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-menu-item-label) {\n  flex: 1 0 0%;\n  text-align: start;\n}\n\n:where(.vds-menu-item .vds-icon, .vds-radio .vds-icon) {\n  --size: var(--item-icon-size);\n  width: var(--size);\n  height: var(--size);\n  margin-right: var(--media-menu-item-icon-spacing, 6px);\n}\n\n:where(.vds-menu-open-icon, .vds-menu-close-icon) {\n  --size: var(--media-menu-arrow-icon-size, 18px);\n  width: var(--size);\n  height: var(--size);\n}\n\n:where(.vds-menu-item-hint, .vds-menu-open-icon, .vds-radio-hint) {\n  color: var(--text-hint-color);\n  font-size: var(--media-menu-hint-font-size, 13px);\n  font-weight: var(--media-menu-hint-font-weight, 400);\n}\n\n:where(.vds-menu-items .vds-menu-open-icon) {\n  margin-right: 0;\n}\n\n:where(.vds-menu-items) :where(.vds-menu-item-hint, .vds-menu-open-icon) {\n  margin-left: auto;\n}\n\n:where(.vds-menu-items) :where(.vds-menu-item-hint + .vds-menu-open-icon),\n:where(.vds-menu-item-hint + media-icon .vds-menu-open-icon),\n:where(.vds-menu-item-hint + slot > .vds-menu-open-icon) {\n  margin-left: 2px;\n}\n\n:where(.vds-menu-item[aria-hidden='true']),\n:where(.vds-menu-item[aria-expanded='true'] .vds-menu-open-icon) {\n  display: none !important;\n}\n\n:where(.vds-menu-items)\n  :where(.vds-menu-item[aria-disabled='true'], .vds-menu-item[data-disabled])\n  :where(.vds-menu-open-icon) {\n  opacity: 0;\n}\n\n:where(.vds-menu-close-icon),\n:where(.vds-menu-item[aria-expanded='true'] > .vds-icon) {\n  display: none !important;\n}\n\n:where(.vds-menu-item[aria-expanded='true'] .vds-menu-close-icon) {\n  display: inline !important;\n  margin-left: calc(-1 * var(--item-padding) / 2);\n}\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Checkbox\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-menu-checkbox) {\n  --checkbox-width: var(--media-menu-checkbox-width, 40px);\n  --checkbox-height: var(--media-menu-checkbox-height, 18px);\n  --checkbox-top: calc((var(--checkbox-height) - var(--checkbox-diameter)) / 2);\n  --checkbox-diameter: var(\n    --media-menu-checkbox-handle-diameter,\n    calc(var(--checkbox-height) - 2px)\n  );\n  --checkbox-gap: var(--media-menu-checkbox-gap, 2.5px);\n  position: relative;\n  display: inline-block;\n  width: var(--checkbox-width);\n  height: var(--checkbox-height);\n  border-radius: calc(var(--checkbox-height) / 2);\n  transition: 0.3s all ease-in-out;\n  box-sizing: border-box;\n  cursor: pointer;\n  pointer-events: auto;\n}\n\n.vds-menu-checkbox {\n  background-color: var(--checkbox-bg);\n}\n\n:where(.vds-menu-checkbox:focus-visible) {\n  outline: none;\n  box-shadow: var(--media-focus-ring);\n}\n\n.vds-menu-checkbox[aria-checked='true'] {\n  background-color: var(--checkbox-active-bg);\n}\n\n:where(.vds-menu-checkbox)::after {\n  content: '';\n  display: inline-block;\n  width: var(--checkbox-diameter);\n  height: var(--checkbox-diameter);\n  border-radius: calc(var(--checkbox-diameter) / 2);\n  position: absolute;\n  top: var(--checkbox-top);\n  transform: translateX(var(--checkbox-gap));\n  transition: 0.3s all ease-in-out;\n  border: var(--checkbox-handle-border);\n  box-sizing: border-box;\n}\n\n.vds-menu-checkbox::after {\n  background-color: var(--checkbox-handle-bg);\n}\n\n:where(.vds-menu-checkbox[aria-checked='true'])::after {\n  transform: translateX(\n    calc(var(--checkbox-width) - var(--checkbox-diameter) - var(--checkbox-gap))\n  );\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  :where(.vds-menu-checkbox[data-active])::after {\n    width: calc(var(--checkbox-width) - calc(var(--checkbox-gap) * 2));\n  }\n}\n\n:where(.vds-menu-checkbox[aria-checked='true'][data-active])::after {\n  transform: translateX(var(--checkbox-gap));\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Slider\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-menu-items .vds-slider) {\n  --media-slider-track-bg: var(--media-menu-slider-track-bg, var(--color-gray-50));\n  --media-slider-track-fill-bg: var(--media-menu-slider-track-fill-bg, var(--color-inverse));\n  --media-slider-height: var(--media-menu-slider-height, 32px);\n  --track-focus-height: var(--track-height) !important;\n}\n\n:where(.vds-menu-items .vds-slider-thumb) {\n  opacity: 1 !important;\n}\n\n:where(.vds-menu-slider-item.group) {\n  flex-direction: column;\n}\n\n:where(.vds-menu-slider-title) {\n  margin-top: 4px;\n}\n\n:where(.vds-menu-slider-body) {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  margin-top: 6px;\n}\n\n:where(.vds-menu-slider-item .vds-icon) {\n  margin: 0;\n  color: var(--text-hint-color);\n}\n\n:where(\n    .vds-menu-slider-item[data-min] .vds-icon.down,\n    .vds-menu-slider-item[data-max] .vds-icon.up\n  ) {\n  color: var(--text-color);\n  animation: 0.6s ease-in-out vds-slider-icon;\n  transition: all 1.2s ease;\n}\n\n@keyframes vds-slider-icon {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.25);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n:where(.vds-menu-items .vds-slider-track-fill) {\n  transition: opacity 0.3s ease;\n}\n\n:where(.vds-menu-items .vds-slider[data-active] .vds-slider-track-fill) {\n  opacity: 0;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Radio\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-radio-group) {\n  box-sizing: border-box;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.vds-radio {\n  cursor: pointer;\n  contain: content;\n  padding-left: calc(var(--item-icon-size) + var(--item-padding));\n}\n\n.vds-radio[aria-checked='true'] {\n  padding-left: 0;\n}\n\n.vds-radio .vds-icon {\n  display: none;\n  color: var(--radio-icon-color);\n}\n\n.vds-radio[aria-checked='true'] .vds-icon {\n  display: inline-block;\n  margin-left: 6px;\n}\n\n:where(.vds-radio-hint) {\n  margin-left: auto;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Color Picker\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n.vds-color-picker {\n  width: 32px;\n  height: 32px;\n  border: 0;\n  background-color: transparent;\n  outline: none;\n}\n\n.vds-color-picker::-webkit-color-swatch {\n  border-radius: 2px;\n}\n\n.vds-color-picker::-moz-color-swatch {\n  border-radius: 2px;\n}\n\n.vds-color-picker:focus-visible::-webkit-color-swatch {\n  box-shadow: var(--media-focus-ring);\n}\n\n.vds-color-picker:focus-visible::-moz-color-swatch {\n  box-shadow: var(--media-focus-ring);\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Menu Section\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-menu-section) {\n  width: 100%;\n}\n\n:where(.vds-menu-item + .vds-menu-section) {\n  margin-top: 8px;\n}\n\n:where(.vds-menu-section + .vds-menu-section) {\n  margin-top: 24px;\n}\n\n:where(.vds-menu-section:first-child) {\n  margin-top: 8px;\n}\n\n:where(.vds-menu-section:last-child) {\n  margin-bottom: 8px;\n}\n\n:where(.vds-menu-section-title),\n:where(.vds-menu-slider-title) {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  color: var(--text-secondary-color);\n  font-size: var(--media-menu-section-header-font-size, 12px);\n  font-weight: var(--media-menu-section-header-font-weight, 500);\n  padding-inline: 2px;\n}\n\n:where(.vds-menu-section-body) {\n  width: 100%;\n}\n\n:where(.vds-menu-section-title + .vds-menu-section-body) {\n  margin-top: var(--media-menu-section-gap, 8px);\n}\n\n.vds-menu-section-body {\n  background-color: var(--section-bg);\n  border: var(--section-border);\n  border-radius: var(--media-menu-section-border-radius, 2px);\n}\n\n:where(.vds-menu-section:not([data-open]) .vds-menu-item:not(:last-child)) {\n  border-bottom: var(--section-divider);\n}\n\n:where(.vds-menu-section-body .vds-menu:last-child > .vds-menu-item) {\n  border-bottom: unset;\n}\n\n.vds-menu-section[data-open],\n.vds-menu-section[data-open] > .vds-menu-section-body {\n  display: contents !important;\n  background-color: transparent !important;\n}\n\n.vds-menu-section[data-open] > .vds-menu-section-title,\n.vds-menu-section[data-open] > .vds-menu-section-body > :not([data-open]) {\n  display: none;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Chapters Menu\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-chapters-menu-items) {\n  min-width: var(--media-chapters-min-width, var(--media-menu-min-width, 220px));\n}\n\n.vds-chapters-menu-items {\n  padding: var(--media-chapters-padding, 0);\n}\n\n:where(.vds-menu-items:has(.vds-chapters-radio-group[data-thumbnails])) {\n  min-width: var(--media-chapters-with-thumbnails-min-width, 300px);\n}\n\n:where(.vds-chapter-radio) {\n  border-radius: 0;\n}\n\n.vds-chapter-radio {\n  border-bottom: var(--chapter-divider);\n  padding: var(--item-padding);\n}\n\n.vds-chapter-radio[aria-checked='true'] {\n  padding-left: var(--item-padding);\n}\n\n:where(.vds-chapter-radio:last-child) {\n  border-bottom: 0;\n}\n\n.vds-chapter-radio[aria-checked='true'] {\n  background-color: var(--chapter-active-bg);\n  border-left: var(--chapter-active-border-left);\n}\n\n:where(.vds-chapter-radio[aria-checked='true']):after {\n  content: ' ';\n  width: var(--progress);\n  height: var(--media-chapters-progress-height, 4px);\n  position: absolute;\n  bottom: 0;\n  left: 0;\n}\n\n.vds-chapter-radio[aria-checked='true']:after {\n  border-radius: var(--media-chapters-progress-border-radius, 0);\n  background-color: var(--chapter-progress-bg);\n}\n\n.vds-chapters-radio-group :where(.vds-thumbnail) {\n  margin-right: var(--media-chapters-thumbnail-gap, 12px);\n  flex-shrink: 0;\n  min-width: var(--media-chapters-thumbnail-min-width, 100px);\n  min-height: var(--media-chapters-thumbnail-min-height, 56px);\n  max-width: var(--media-chapters-thumbnail-max-width, 120px);\n  max-height: var(--media-chapters-thumbnail-max-height, 68px);\n}\n\n.vds-chapters-radio-group .vds-thumbnail {\n  border: var(--media-chapters-thumbnail-border, 0);\n}\n\n:where(.vds-chapters-radio-group .vds-chapter-radio-label) {\n  color: var(--text-secondary-color);\n  font-size: var(--font-size);\n  font-weight: var(--font-weight);\n  white-space: nowrap;\n}\n\n:where(.vds-chapter-radio[aria-checked='true'] .vds-chapter-radio-label) {\n  color: var(--text-color);\n}\n\n:where(.vds-chapters-radio-group .vds-chapter-radio-start-time) {\n  display: inline-block;\n  letter-spacing: var(--media-chapters-start-time-letter-spacing, 0.4px);\n  border-radius: var(--media-chapters-start-time-border-radius, 2px);\n  font-size: var(--chapter-time-font-size);\n  font-weight: var(--chapter-time-font-weight);\n  margin-top: var(--chapter-time-gap);\n}\n\n.vds-chapters-radio-group .vds-chapter-radio-start-time {\n  color: var(--text-secondary-color);\n  background-color: var(--section-bg);\n  padding: var(--media-chapters-start-time-padding, 1px 4px);\n}\n\n:where(.vds-chapters-radio-group .vds-chapter-radio-duration) {\n  color: var(--text-hint-color);\n  font-size: var(--chapter-time-font-size);\n  font-weight: var(--chapter-time-font-weight);\n  margin-top: var(--chapter-time-gap);\n}\n\n.vds-chapters-radio-group .vds-chapter-radio-duration {\n  background-color: var(--chapter-duration-bg);\n  border-radius: var(--media-chapters-duration-border-radius, 2px);\n}\n\n.vds-chapters-radio-group:not([data-thumbnails]) :where(.vds-thumbnail, media-thumbnail) {\n  display: none;\n}\n\n:where(.vds-chapter-radio-content) {\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n}\n\n:where(.vds-chapters-radio-group:not([data-thumbnails]) .vds-chapter-radio-content) {\n  width: 100%;\n  flex-direction: row;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n:where(.vds-chapters-radio-group:not([data-thumbnails]) .vds-chapter-radio-start-time) {\n  margin-top: 0;\n  margin-left: auto;\n}\n\n:where(.vds-chapters-radio-group:not([data-thumbnails]) .vds-chapter-radio-duration) {\n  margin-top: 4px;\n  flex-basis: 100%;\n}\n\n.vds-menu-items[data-keyboard] .vds-chapters-radio-group:focus-within {\n  padding: var(--media-chapters-focus-padding, 4px);\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Poster\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-poster) {\n  display: block;\n  contain: content;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 0;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  border: 0;\n  pointer-events: none;\n  box-sizing: border-box;\n  transition: opacity 0.2s ease-out;\n  background-color: var(--media-poster-bg, black);\n}\n\n:where(.vds-poster img) {\n  object-fit: inherit;\n  object-position: inherit;\n  pointer-events: none;\n  user-select: none;\n  -webkit-user-select: none;\n  box-sizing: border-box;\n}\n\n.vds-poster :where(img) {\n  border: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n:where(.vds-poster[data-hidden]) {\n  display: none;\n}\n\n:where(.vds-poster[data-visible]) {\n  opacity: 1;\n}\n\n.vds-poster:not(:defined),\n.vds-poster img:not([src]) {\n  display: none;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Sliders\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-slider) {\n  --width: var(--media-slider-width, 100%);\n  --height: var(--media-slider-height, 48px);\n\n  --thumb-size: var(--media-slider-thumb-size, 15px);\n  --thumb-focus-size: var(--media-slider-focused-thumb-size, calc(var(--thumb-size) * 1.1));\n\n  --track-width: var(--media-slider-track-width, 100%);\n  --track-height: var(--media-slider-track-height, 5px);\n  --track-focus-width: var(--media-slider-focused-track-width, var(--track-width));\n  --track-focus-height: var(--media-slider-focused-track-height, calc(var(--track-height) * 1.25));\n\n  display: inline-flex;\n  align-items: center;\n  width: var(--width);\n  height: var(--height);\n  /** Prevent thumb flowing out of slider. */\n  margin: 0 calc(var(--thumb-size) / 2);\n  position: relative;\n  contain: layout style;\n  outline: none;\n  pointer-events: auto;\n  cursor: pointer;\n  user-select: none;\n  touch-action: none;\n  -webkit-user-select: none;\n  -webkit-tap-highlight-color: transparent;\n}\n\n:where(.vds-slider[aria-hidden='true']) {\n  display: none !important;\n}\n\n:where(.vds-slider[aria-disabled='true']) {\n  cursor: unset;\n}\n\n:where(.vds-slider:focus) {\n  outline: none;\n}\n\n:where(.vds-slider:not([data-chapters])[data-focus], .vds-slider:not([data-chapters]):focus-visible)\n  :where(.vds-slider-track) {\n  box-shadow: var(--media-focus-ring);\n}\n\n:where(.vds-slider .vds-slider-track) {\n  z-index: 0;\n  position: absolute;\n  width: var(--track-width);\n  height: var(--track-height);\n  top: 50%;\n  left: 0;\n  border-radius: var(--media-slider-track-border-radius, 2px);\n  transform: translateY(-50%) translateZ(0);\n  background-color: var(--media-slider-track-bg, rgb(255 255 255 / 0.3));\n  contain: strict;\n}\n\n:where(.vds-slider[data-focus], .vds-slider:focus-visible) :where(.vds-slider-track) {\n  outline-offset: var(--thumb-size);\n}\n\n:where(.vds-slider:not([data-chapters])[data-active] .vds-slider-track) {\n  width: var(--track-focus-width);\n  height: var(--track-focus-height);\n}\n\n:where(.vds-slider .vds-slider-track-fill) {\n  z-index: 2; /** above track and track progress. */\n  background-color: var(--media-slider-track-fill-bg, var(--media-brand));\n  width: var(--slider-fill, 0%);\n  will-change: width;\n}\n\n:where(.vds-slider .vds-slider-thumb) {\n  position: absolute;\n  top: 50%;\n  left: var(--slider-fill);\n  opacity: 0;\n  contain: layout size style;\n  width: var(--thumb-size);\n  height: var(--thumb-size);\n  border: var(--media-slider-thumb-border, 1px solid #cacaca);\n  border-radius: var(--media-slider-thumb-border-radius, 9999px);\n  background-color: var(--media-slider-thumb-bg, #fff);\n  transform: translate(-50%, -50%) translateZ(0);\n  transition: opacity 0.15s ease-in;\n  pointer-events: none;\n  will-change: left;\n  z-index: 2; /** above track fill. */\n}\n\n:where(.vds-slider[data-dragging], .vds-slider[data-focus], .vds-slider:focus-visible)\n  :where(.vds-slider-thumb) {\n  box-shadow: var(--media-slider-focused-thumb-shadow, 0 0 0 4px hsla(0, 0%, 100%, 0.4));\n}\n\n:where(.vds-slider[data-active] .vds-slider-thumb) {\n  opacity: 1;\n  transition: var(--media-slider-thumb-transition, opacity 0.2s ease-in, box-shadow 0.2s ease);\n}\n\n:where(.vds-slider[data-dragging] .vds-slider-thumb) {\n  width: var(--thumb-focus-size);\n  height: var(--thumb-focus-size);\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Slider Value\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-slider-value) {\n  display: inline-block;\n  contain: content;\n  font-size: 14px;\n  font-family: var(--media-font-family, sans-serif);\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Slider Thumbnail\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-slider-thumbnail) {\n  display: block;\n  contain: content;\n  box-sizing: border-box;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Slider Video\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-slider-video) {\n  background-color: black;\n  box-sizing: border-box;\n  contain: content;\n  display: inline-block;\n  border: var(--media-thumbnail-border, 1px solid white);\n}\n\n:where(.vds-slider-video video) {\n  display: block;\n  height: auto;\n  width: 156px;\n}\n\n/* Temporarily hide video while loading. */\n:where(.vds-slider-video[data-loading]) {\n  opacity: 0;\n}\n\n/* Hide video if it fails to load. */\n:where(.vds-slider-video[data-hidden], .vds-slider-video[data-hidden] video) {\n  display: none;\n  width: 0px;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Previews\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-slider .vds-slider-preview) {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  opacity: 0;\n  background-color: var(--media-slider-preview-bg);\n  border-radius: var(--media-slider-preview-border-radius, 2px);\n  pointer-events: none;\n  transition: opacity 0.2s ease-out;\n  will-change: left, opacity;\n  contain: layout paint style;\n}\n\n:where(.vds-slider-preview[data-visible]) {\n  opacity: 1;\n  transition: opacity 0.2s ease-in;\n}\n\n.vds-slider-value {\n  background-color: var(--media-slider-value-bg, black);\n  border-radius: var(--media-slider-value-border-radius, 2px);\n  border: var(--media-slider-value-border);\n  color: var(--media-slider-value-color, white);\n  padding: var(--media-slider-value-padding, 1px 10px);\n}\n\n:where(\n    .vds-slider-video:not([data-hidden]) + .vds-slider-chapter-title,\n    .vds-slider-thumbnail:not([data-hidden]) + .vds-slider-chapter-title\n  ) {\n  margin-top: var(--media-slider-chapter-title-gap, 6px);\n}\n\n:where(\n    .vds-slider-video:not([data-hidden]) + .vds-slider-value,\n    .vds-slider-thumbnail:not([data-hidden]) + .vds-slider-value,\n    .vds-slider-chapter-title + .vds-slider-value\n  ) {\n  margin-top: var(--media-slider-value-gap, 2px);\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Vertical Sliders\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-slider[aria-orientation='vertical']) {\n  --width: var(--media-slider-width, 48px);\n  --height: var(--media-slider-height, 100%);\n\n  --track-width: var(--media-slider-track-width, 4px);\n  --track-height: var(--media-slider-track-height, 100%);\n  --track-focus-width: var(--media-slider-focused-track-width, calc(var(--track-width) * 1.25));\n  --track-focus-height: var(--media-slider-focused-track-height, var(--track-height));\n\n  /** Prevent thumb flowing out of slider. */\n  margin: calc(var(--thumb-size) / 2) 0;\n}\n\n:where(.vds-slider[aria-orientation='vertical'] .vds-slider-track) {\n  top: unset;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%) translateZ(0);\n}\n\n:where(.vds-slider[aria-orientation='vertical'] .vds-slider-track-fill) {\n  width: var(--track-width);\n  height: var(--slider-fill);\n  will-change: height;\n  transform: translateX(-50%) translateZ(0);\n}\n\n:where(.vds-slider[aria-orientation='vertical'] .vds-slider-progress) {\n  top: unset;\n  bottom: 0;\n  width: var(--track-width);\n  height: var(--slider-progress, 0%);\n  will-change: height;\n}\n\n:where(.vds-slider[aria-orientation='vertical'] .vds-slider-thumb) {\n  top: unset;\n  bottom: var(--slider-fill);\n  left: 50%;\n  will-change: bottom;\n  transform: translate(-50%, 50%) translateZ(0);\n}\n\n:where(.vds-slider[aria-orientation='vertical'] .vds-slider-preview) {\n  will-change: bottom, opacity;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Time Slider\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where([data-live] .vds-time-slider .vds-slider-track-fill) {\n  background-color: var(--media-slider-track-fill-live-bg, #dc2626);\n}\n\n:where(.vds-time-slider .vds-slider-progress) {\n  z-index: 1; /** above track. */\n  left: 0;\n  width: var(--slider-progress, 0%);\n  will-change: width;\n  background-color: var(--media-slider-track-progress-bg, rgb(255 255 255 / 0.5));\n}\n\n:where([data-media-player]:not([data-can-play]) .vds-time-slider .vds-slider-value) {\n  display: none;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Slider Steps\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-slider-steps) {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n:where(.vds-slider-step) {\n  width: var(--media-slider-step-width, 2.5px);\n  height: calc(var(--track-height) + 1px);\n  background-color: var(--media-slider-step-color, rgb(124, 124, 124));\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n:where(.vds-slider[data-active] .vds-slider-step) {\n  opacity: 1;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Slider Chapters\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-time-slider .vds-slider-chapters) {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  contain: layout style;\n  border-radius: var(--media-slider-track-border-radius, 1px);\n}\n\n:where(.vds-slider[data-focus], .vds-slider:focus-visible) :where(.vds-slider-chapters) {\n  box-shadow: var(--media-focus-ring);\n  height: var(--track-height);\n}\n\n:where(.vds-time-slider .vds-slider-chapter) {\n  margin-right: 2px;\n}\n\n:where(.vds-time-slider .vds-slider-chapter:last-child) {\n  margin-right: 0;\n}\n\n:where(.vds-time-slider .vds-slider-chapter) {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  will-change: height, transform;\n  contain: layout style;\n  border-radius: var(--media-slider-track-border-radius, 1px);\n}\n\n:where(.vds-time-slider .vds-slider-chapter .vds-slider-track-fill) {\n  width: var(--chapter-fill, 0%);\n  will-change: width;\n}\n\n:where(.vds-time-slider .vds-slider-chapter .vds-slider-progress) {\n  width: var(--chapter-progress, 0%);\n  will-change: width;\n}\n\n@media (hover: hover) and (pointer: fine) {\n  :where(.vds-time-slider:hover .vds-slider-chapters) {\n    contain: strict;\n  }\n\n  :where(.vds-time-slider .vds-slider-chapter:hover:not(:only-of-type)) {\n    transform: var(--media-slider-chapter-hover-transform, scaleY(2));\n    transition: var(\n      --media-slider-chapter-hover-transition,\n      transform 0.1s cubic-bezier(0.4, 0, 1, 1)\n    );\n  }\n}\n\n:where(.vds-time-slider .vds-slider-chapter-title) {\n  font-family: var(--media-font-family, sans-serif);\n  font-size: var(--media-slider-chapter-title-font-size, 14px);\n  color: var(--media-slider-chapter-title-color, #f5f5f5);\n  background-color: var(--media-slider-chapter-title-bg);\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Thumbnail\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-thumbnail) {\n  --min-width: var(--media-thumbnail-min-width, 140px);\n  --max-width: var(--media-thumbnail-max-width, 180px);\n  --aspect-ratio: var(--media-thumbnail-aspect-ratio, var(--thumbnail-aspect-ratio));\n  display: block;\n  width: var(--thumbnail-width);\n  height: var(--thumbnail-height);\n  background-color: var(--media-thumbnail-bg, black);\n  contain: strict;\n  overflow: hidden;\n  box-sizing: border-box;\n  min-width: var(--min-width);\n  min-height: var(--media-thumbnail-min-height, calc(var(--min-width) / var(--aspect-ratio)));\n  max-width: var(--max-width);\n  max-height: var(--media-thumbnail-max-height, calc(var(--max-width) / var(--aspect-ratio)));\n}\n\n.vds-thumbnail {\n  border: var(--media-thumbnail-border, 1px solid white);\n}\n\n:where(.vds-thumbnail img) {\n  min-width: unset !important;\n  max-width: unset !important;\n  will-change: width, height, transform;\n}\n\n:where(.vds-thumbnail[data-loading] img) {\n  opacity: 0;\n}\n\n:where(.vds-thumbnail[aria-hidden='true']) {\n  display: none !important;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Time\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-time-group) {\n  display: flex;\n  align-items: center;\n}\n\n.vds-time-divider {\n  margin: 0 var(--media-time-divider-gap, 2.5px);\n  color: var(--media-time-divider-color, #e0e0e0);\n}\n\n:where(.vds-time) {\n  display: inline-block;\n  contain: content;\n  font-size: var(--media-time-font-size, 15px);\n  font-weight: var(--media-time-font-weight, 400);\n  font-family: var(--media-font-family, sans-serif);\n  border-radius: var(--media-time-border-radius, 2px);\n  letter-spacing: var(--media-time-letter-spacing, 0.025em);\n}\n\n.vds-time {\n  outline: 0;\n  color: var(--media-time-color, var(--default-color));\n  background-color: var(--media-time-bg);\n  border: var(--media-time-border);\n  padding: var(--media-time-padding, 2px);\n}\n\n:where(.vds-time:focus-visible) {\n  box-shadow: var(--media-focus-ring);\n}\n\n.light .vds-time {\n  --default-color: rgb(10 10 10);\n}\n\n.dark .vds-time {\n  --default-color: #f5f5f5;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Tooltips\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-tooltip, media-tooltip) {\n  display: contents;\n}\n\n:where(.vds-tooltip-content) {\n  display: inline-block;\n  box-sizing: border-box;\n  font-family: var(--media-font-family, sans-serif);\n  font-size: var(--media-tooltip-font-size, 13px);\n  font-weight: var(--media-tooltip-font-weight, 500);\n  opacity: 0;\n  pointer-events: none;\n  white-space: nowrap;\n  z-index: 10;\n  will-change: transform, opacity;\n}\n\n.vds-tooltip-content {\n  border-radius: var(--media-tooltip-border-radius, 2px);\n  background-color: var(--media-tooltip-bg-color, var(--default-bg));\n  border: var(--media-tooltip-border, var(--default-border));\n  color: var(--media-tooltip-color, var(--default-color));\n  padding: var(--media-tooltip-padding, 2px 8px);\n}\n\n.light .vds-tooltip-content {\n  --default-color: #1a1a1a;\n  --default-bg: white;\n  --default-border: 1px solid rgb(0 0 0 / 0.2);\n}\n\n.dark .vds-tooltip-content {\n  --default-color: #f5f5f5;\n  --default-bg: black;\n  --default-border: 1px solid rgb(255 255 255 / 0.1);\n}\n\n:where(.vds-menu .vds-menu-button[role='button'][data-pressed] .vds-tooltip-content) {\n  opacity: 0;\n  display: none;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Tooltip Animation\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-tooltip-content) {\n  --enter-transform: translateY(0px) scale(1);\n  --exit-transform: translateY(12px) scale(0.8);\n}\n\n:where(.vds-tooltip-content:not([data-visible])) {\n  animation: var(--media-tooltip-exit-animation, vds-tooltip-exit 0.2s ease-out);\n}\n\n:where(.vds-tooltip-content[data-visible]) {\n  animation: var(--media-tooltip-enter-animation, vds-tooltip-enter 0.2s ease-in);\n  animation-fill-mode: forwards;\n}\n\n/* Bottom */\n:where(.vds-tooltip-content[data-placement~='bottom']) {\n  --enter-transform: translateY(0) scale(1);\n  --exit-transform: translateY(-12px) scale(0.8);\n}\n\n/* Left */\n:where(.vds-tooltip-content[data-placement~='left']) {\n  --enter-transform: translateX(0) scale(1);\n  --exit-transform: translateX(12px) scale(0.8);\n}\n\n/* Right */\n:where(.vds-tooltip-content[data-placement~='right']) {\n  --enter-transform: translateX(0) scale(1);\n  --exit-transform: translateX(-12px) scale(0.8);\n}\n\n@keyframes vds-tooltip-enter {\n  from {\n    opacity: 0;\n    transform: var(--exit-transform);\n  }\n  to {\n    opacity: 1;\n    transform: var(--enter-transform);\n  }\n}\n\n@keyframes vds-tooltip-exit {\n  from {\n    opacity: 1;\n    transform: var(--enter-transform);\n  }\n  to {\n    opacity: 0;\n    transform: var(--exit-transform);\n  }\n}\n\n@media (prefers-reduced-motion) {\n  :where(.vds-tooltip-content) {\n    animation: none;\n  }\n\n  :where(.vds-tooltip-content[data-visible]) {\n    opacity: 1;\n  }\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * States\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n/* Play Button */\n[data-media-player]:not([data-paused]) .vds-play-tooltip-text,\n[data-media-player][data-paused] .vds-pause-tooltip-text,\n/* PIP Button */\n[data-media-player][data-pip] .vds-pip-enter-tooltip-text,\n[data-media-player]:not([data-pip]) .vds-pip-exit-tooltip-text,\n/* Fullscreen Button */\n[data-media-player][data-fullscreen] .vds-fs-enter-tooltip-text,\n[data-media-player]:not([data-fullscreen]) .vds-fs-exit-tooltip-text,\n/* Caption Button */\n[data-media-player]:not([data-captions]) .vds-cc-on-tooltip-text,\n[data-media-player][data-captions] .vds-cc-off-tooltip-text,\n/* Mute Button */\n[data-media-player]:not([data-muted]) .vds-mute-tooltip-text,\n[data-media-player][data-muted] .vds-unmute-tooltip-text {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
